/**
 * PreorderPro storefront script v52
 * v52: Loads hs-thought.js, date plan, remembered size, size change; silent until
 *      the growth lab has the tests.
 * v51: Loads hs-offer.js, «Ти, мабуть, зараз думаєш»; silent until the growth lab has
 *      the test.
 * v50: Loads hs-ask.js, the «Що поки стримує?» slip; silent until the growth lab
 *      has the test.
 * v49: Black Friday is now «купи дві, третя безкоштовно» (hs-bf.js); while it
 *      runs, window.__HS_SETS_OFF keeps Buy20/25/30 off the cart.
 * v48: Loads hs-clarity.js, site tests from the Clarity read; silent until the
 *      growth lab has the test.
 * v47: Loads hs-bf.js, «Чорна пʼятниця» (banner, hero-page line, cart bra
 *      picker); silent unless /admin/black-friday is on. A gift line
 *      (_hs_gift) is not counted toward set prices.
 * v46: Loads hs-parts.js — «або N платежів по … ₴ без переплат · Покупка
 *      частинами monobank» under the price; silent unless that payment
 *      method is on at /admin/bank-pay#parts.
 * v45: Loads hs-stock.js — «Повідомити, коли буде в наявності» on a sold-out
 *      size, our own in place of Cartbite; silent unless /admin/back-in-stock is on.
 * v44: Loads hs-lab.js — the growth lab's funnel events and test widgets;
 *      silent unless tracking is on at /admin/lab.
 * v43: Loads hs-size.js — our own size table and «Підібрати мій розмір»
 *      helper in place of the Kiwi popup; silent unless the switch on
 *      /admin/size-chart is on (or ?hs_size=1 in this tab).
 * v41: Loads hs-me.js — «Твій статус», a returning client's level and cashback
 *      under the price on the product page. Separate asset, silent unless the
 *      app's switch on /admin/tiers is on. The query string is captured before
 *      ?hs_vip= is stripped below, so hs-me.js can use the same link.
 * v40: Collection cards: picking another colour rebuilds the «Передзамовлення /
 *      Є зараз / Розпродано» box for that colour's sizes. The theme only hides
 *      and shows pills, which the add-nodes observer never saw.
 * v39: «Доставка й оплата». A quiet block under the buy button and next to the
 *      cart delivery picker: when we ship (the same ETA as the legend; the
 *      whole-order date in the cart), payment methods, exchange/return terms.
 *      Facts come from settings.delivery_block; off unless its switch is on
 *      (or ?hs_delivery_preview=1 in this browser). See «hs-delivery-block».
 * v38: «Відправити частинами». While the app's split switch is on and the cart
 *      holds pre-order AND in-stock items, the cart banner carries a tickbox.
 *      Ticking it writes the cart attribute «Відправка частинами: Так» (it
 *      reaches the order) and the first line says two parcels; the app turns
 *      the paid order into two orders. A tick left in a cart that is no longer
 *      mixed is cleared.
 * v37: The cart banner tells the truth about shipping. The warehouse sends an
 *      order in one parcel once every item is there, so the banner no longer
 *      says the rest ships as usual or «частинами»: {{eta}} is the latest
 *      pre-order date in the cart, not a list of every date.
 * v36: VIP early access. New products announced to VIP and Gold are hidden
 *      from everyone else for the window the app reports: cards vanish from
 *      collections, search and recommendations, and the product page shows
 *      a lock instead of add-to-cart. The personal link in the VIP email
 *      (?hs_vip=) unlocks this browser. Fails open on any error.
 * v35: Every collection card gets the legend, not only the ones with a
 *      pre-order. A card whose sizes are all in stock used to render nothing
 *      and left a blank hole in the grid beside cards that had a box; it now
 *      says «Є зараз: …» and «Розпродано: …» in the same box. Size rows inside
 *      a product form are skipped — the product page has its own legend.
 * v34: Truth and one voice. The legend under the sizes is built from real
 *      stock per colour — pre-order sizes with their own dates, sizes in stock,
 *      sizes sold out — so it can never claim «інші розміри в наявності» when
 *      nothing is. Every pre-order size of the chosen colour wears the clock
 *      (a drawn SVG, not an emoji), including the selected one; the dot never
 *      lands on the hidden pickup-availability element again. The notice under
 *      the button is one readable sentence in «ти» (oплата зараз, відправка
 *      близько …, гарантія діє). Dates read «25 вересня». The button carries an
 *      aria-label so its name matches what is drawn. Cart: a banner lists the
 *      dates of every pre-order line; the theme's «1-2 дні» promise is softened
 *      while a pre-order is in the cart; cart polling only runs where a cart
 *      is visible. Colours come from the brand's Rose Gold with ink text.
 * v33: Pre-order sizes marked by a clock dot + one legend line, not a word
 *      squeezed onto a 30px pill. Collection/search cards now get their own
 *      precise pass: the theme's .size-pill buttons carry data-variant-id, so
 *      each card marks exactly its own pre-order sizes (the old text-matching
 *      badged look-alike pills on unrelated cards).
 * v32: Two storefront fixes.
 *      1) Hide Shopify's dynamic checkout buttons (Buy it now / Shop Pay) while
 *         a variant is in pre-order — they bypass the cart and our pre-order
 *         line-item properties.
 *      2) Force the pre-order button to a filled accent background with white
 *         text so the label is always readable (some themes render a
 *         white/outline buy button, which made the overlay white-on-white).
 * v31
 * v31: Conflict-hide now also matches Russian copy ("распродано", "нет в
 *      наличии", "уведомить/сообщить когда появится") in addition to the
 *      Ukrainian/English patterns — the storefront mixes RU and UA strings.
 * v30
 * v30: Two fixes for Debutify (and themes that gate the form by variant).
 *      1) findMainProductForm() now resolves the form by the product's FULL
 *         variant-id set (from product.js), not just pre-order variants. Before,
 *         switching to a plain sold-out variant lost the form, so the previous
 *         variant's pre-order notice/button never got cleaned up.
 *      2) Conflict-hide now re-runs on DOM mutations (the notify button +
 *         sold-out badge are injected asynchronously, so a one-shot hide missed
 *         them) and matches Ukrainian copy too ("немає в наявності",
 *         "розпродано", "повідомити").
 * v29: Hide the theme's conflicting sold-out UI while pre-order is active.
 * v29: Hide the theme's conflicting sold-out UI while pre-order is active.
 *      When a variant flips to pre-order, the theme was still showing its
 *      native "Sold out / No longer available" badge, the "already sold out"
 *      message, and a back-in-stock "Notify me when available" button — all
 *      contradicting the pre-order CTA. setPreorderConflictsHidden() now hides
 *      them (scoped to the product area, by class + visible text), and restores
 *      them when the variant is no longer pre-order. Reversible.
 * v28: Per-shop settings get more powerful.
 *      - New show_corner_tag / show_notice toggles let merchants hide UI
 *        pieces they don't want without writing CSS.
 *      - New max_qty_per_order caps the line-item quantity input on the
 *        product form AND on AJAX cart-add bodies.
 *      - New cod_warning_enabled + cod_warning_text drives a small banner
 *        injected right above the checkout button whenever the cart
 *        contains a pre-order line. Cart polling is throttled (one /cart.js
 *        GET every 4s + on click), banner is auto-removed when the cart
 *        no longer has a pre-order item.
 *      - New custom_css setting is injected into a <style id="hs-po-custom-css">
 *        tag so power-users can override anything.
 *      - Every pre-order line item now also gets the property
 *        `_hs_preorder=true`, in addition to the existing `_preorder_eta` +
 *        `Pre-Order` properties. Merchants can match on that exact key in
 *        their Shopify Payment Customization rules to actually hide COD at
 *        checkout (the in-cart banner is just a heads-up).
 * v27: Two fixes:
 * v27: Two fixes:
 *      1) API is the source of truth for "has active PO". Stale Liquid
 *         metafields from cancelled/completed POs were falsely flipping
 *         the button to pre-order on plain old out-of-stock variants.
 *         Once /api/preorder-variants has loaded, only variants in that
 *         response count. Falls back to Liquid only while the API is in
 *         flight.
 *      2) Long button copy (e.g. Ukrainian "Preorder - Предзамовлення
 *         – відправка буде June 15, 2026") was getting truncated with
 *         an ellipsis. Switched ::after to white-space:normal + word-
 *         wrap so it flows onto two lines, and ramp --hs-po-font-size
 *         down dynamically based on text length so it still fits in a
 *         single-line button height when possible.
 * v26: Render label via CSS ::after pseudo-element.
 * v26: CSS pseudo-element label. v25 still lost the race against the
 *      Fabrikator theme, which sets every <span> inside its buy button
 *      back to "В Кошик-->" on every variant change. Our .hs-po-label
 *      kept getting its textContent overwritten by the theme.
 *      Fix: render the label via a `::after` pseudo-element on the
 *      button itself, with `content: attr(data-hs-po-text)`. The text
 *      lives on the button's data attribute and is rendered by CSS,
 *      not as a DOM element. Theme JS can't see or modify pseudo
 *      elements. Color is passed via a CSS custom property.
 * v25: Inline label styles, simpler hiding CSS.
 * v25: Fix the empty-button regression from v24. v24's CSS used the
 *      :not(.hs-po-label *) selector form, which has spotty browser
 *      support — when it failed, our overlay label inherited
 *      visibility:hidden along with the theme text. Switched to inline
 *      styles on the label so no external CSS specificity battle can
 *      hide it, and simplified the hiding CSS to "hide direct children,
 *      re-show our label and its subtree". Theme text is hidden TWO
 *      ways now: color:transparent on the button (inherits down) AND
 *      visibility:hidden on direct children.
 * v24: Bulletproof button text replacement.
 * v24: Bulletproof button text replacement. Themes that nest the button
 *      text deep enough (or restore it after every variant change) kept
 *      "В Кошик" / "Add to cart" / etc. visible alongside our injected
 *      label. Switched from "clear theme text + insert our text" to
 *      "hide everything inside the button with visibility:hidden, then
 *      overlay our .hs-po-label positioned absolutely on top". This
 *      works regardless of how deeply the theme buries its text, what
 *      its mutation timing is, or whether it uses CSS pseudo-elements.
 *      The button's click handler is untouched so add-to-cart still
 *      fires normally.
 * v23: Recursive text clearing on the buy button.
 * v23: Recursive text clearing on the buy button. The previous version only
 *      blanked direct text-node children of the button, which left themes
 *      that nest the "Add to cart" label inside <span>/<div> with the
 *      original text still visible alongside our injected "Pre-Order"
 *      label. Now we walk the entire descendant tree, clear every
 *      meaningful text node, and skip only nodes inside .hs-po-label.
 *      Also tightens the CSS: hide every direct child that isn't our
 *      label, except svg / spinner / loader elements.
 * v22: Multi-tenant + customizable.
 * v22: Multi-tenant + customizable. Fetches per-shop settings from the app
 *      (window.__HS_PREORDER_SETTINGS_API). Button text, corner tag, notice,
 *      and accent color are now driven by what the merchant set in Settings,
 *      not hard-coded. Lebanon-only guard removed — country restriction (if
 *      any) is configured per-shop in the app backend now.
 * v21: Much more visible pre-order indicator.
 *      - Replaces the tiny 8px corner dot with a "PRE-ORDER" tag tucked into
 *        the top-right corner of the size button (small but readable).
 *      - Adds a 1.5px camel border around the whole button via inset shadow,
 *        so the button itself reads as different from a glance.
 *      - Kept the bottom accent line as a fallback signal.
 * v20: Badge only the Size picker (skip Color, Material, etc.). Color swatches
 *      are inherently small and the dot crowded them; the size grid is where
 *      customers actually scan. Matches any option whose name contains "size"
 *      (case-insensitive) — so 'Size', 'Bra Size', 'Size (UK)' all qualify.
 * v19: Fix TypeError when product.options contains objects (modern Shopify
 *      theme format: [{name:'Color',values:[...]}, {name:'Size',values:[...]}]
 *      rather than the legacy ['Color', 'Size']). v18 crashed on first iteration
 *      so no picker decoration ran at all.
 * v18: Variant-picker decoration — robust matcher + clip-safe indicator.
 *      - Now matches pickers by data-variant-id when present (most accurate),
 *        then by fuzzy text (handles screen-reader prefixes like "Size: XS/S").
 *      - Indicator is now a small camel-coloured dot INSIDE the button at the
 *        top-right corner, so it survives buttons with overflow:hidden.
 *      - Also adds a thin bottom accent line for clearer at-a-glance signal.
 *      - Logs a one-line diagnostic on first decorate so we can debug from the
 *        browser console: '[HS Preorder] picker decorated: N elements'.
 * v17: Initial variant-picker decoration.
 * v16: Customer-side Lebanon-market guard added. Non-Lebanon visitors
 *      (e.g. Qatar via Shopify Markets) skip ALL pre-order behavior.
 * v15: System is now Beirut-location + Lebanon-market EXCLUSIVE.
 *      Product page inventory check now uses Beirut-only API data
 *      (Liquid total inventory is fallback only).
 * v14: Stock-aware on EVERY page — uses inventory data from the
 *      /api/preorder-variants endpoint (which fetches Beirut stock).
 * v13: Works on every page (quick-add, recommendations, etc.)
 * v12: Inventory from Liquid (product.js hides it on this store).
 * v11: Only show pre-order when stock = 0.
 * v10: Match the right Add-to-Cart form when page has multiple ones.
 */
(function () {
  'use strict';

  // v41: «Твій статус» (hs-me.js, next to this file in the theme's assets).
  // The version is stamped in by the app's theme sync, so a change to either
  // file reaches browsers past the CDN cache.
  try {
    if (window.__HS_INITIAL_SEARCH == null) window.__HS_INITIAL_SEARCH = window.location.search;
    var selfSrc = document.currentScript && document.currentScript.src;
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && !document.getElementById('hs-me-loader')) {
      var meScript = document.createElement('script');
      meScript.id = 'hs-me-loader';
      meScript.async = true;
      meScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-me.js?v=f649263f5e12');
      document.head.appendChild(meScript);
    }
    // v42: «Відгуки з Instagram» (hs-ugc.js) — our replacement for Instafeed.
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && !document.getElementById('hs-ugc-loader')) {
      var ugcScript = document.createElement('script');
      ugcScript.id = 'hs-ugc-loader';
      ugcScript.async = true;
      ugcScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-ugc.js?v=f86f11f43343');
      document.head.appendChild(ugcScript);
    }
    // v43: own size table + size helper (hs-size.js).
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && !document.getElementById('hs-size-loader')) {
      var sizeScript = document.createElement('script');
      sizeScript.id = 'hs-size-loader';
      sizeScript.async = true;
      sizeScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-size.js?v=74cff3529dc6');
      document.head.appendChild(sizeScript);
    }
    // v44: «Тести» (hs-lab.js): the shop's funnel and the growth lab's test widgets.
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && !document.getElementById('hs-lab-loader')) {
      var labScript = document.createElement('script');
      labScript.id = 'hs-lab-loader';
      labScript.async = true;
      labScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-lab.js?v=3e3b5c4d4927');
      document.head.appendChild(labScript);
    }
    // v45: «Повідомити, коли буде в наявності» (hs-stock.js), product pages only.
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && /\/products\//.test(location.pathname) && !document.getElementById('hs-stock-loader')) {
      var stockScript = document.createElement('script');
      stockScript.id = 'hs-stock-loader';
      stockScript.async = true;
      stockScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-stock.js?v=aebda7a0d30c');
      document.head.appendChild(stockScript);
    }
    // v50: «Що поки стримує?» (hs-ask.js).
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && !document.getElementById('hs-ask-loader')) {
      var askScript = document.createElement('script');
      askScript.id = 'hs-ask-loader';
      askScript.async = true;
      askScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-ask.js?v=60135b141da4');
      document.head.appendChild(askScript);
    }
    // v51: «Ти, мабуть, зараз думаєш» (hs-offer.js), product pages only.
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && /\/products\//.test(location.pathname) && !document.getElementById('hs-offer-loader')) {
      var offerScript = document.createElement('script');
      offerScript.id = 'hs-offer-loader';
      offerScript.async = true;
      offerScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-offer.js?v=19f6580383a2');
      document.head.appendChild(offerScript);
    }
    // v52: hs-thought.js, product pages only.
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && /\/products\//.test(location.pathname) && !document.getElementById('hs-thought-loader')) {
      var thoughtScript = document.createElement('script');
      thoughtScript.id = 'hs-thought-loader';
      thoughtScript.async = true;
      thoughtScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-thought.js?v=67b5b1ce4c86');
      document.head.appendChild(thoughtScript);
    }
    // v48: site tests from the Clarity read (hs-clarity.js).
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && !document.getElementById('hs-clarity-loader')) {
      var clarityScript = document.createElement('script');
      clarityScript.id = 'hs-clarity-loader';
      clarityScript.async = true;
      clarityScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-clarity.js?v=d6823e8160fc');
      document.head.appendChild(clarityScript);
    }
    // v47: «Чорна пʼятниця» banner, product line and cart bar (hs-bf.js).
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && !document.getElementById('hs-bf-loader')) {
      var bfScript = document.createElement('script');
      bfScript.id = 'hs-bf-loader';
      bfScript.async = true;
      bfScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-bf.js?v=96bfbe986a6e');
      document.head.appendChild(bfScript);
    }
    // v46: «Покупка частинами» monobank line under the price (hs-parts.js).
    if (selfSrc && /hs-preorder\.js/.test(selfSrc) && !document.getElementById('hs-parts-loader')) {
      var partsScript = document.createElement('script');
      partsScript.id = 'hs-parts-loader';
      partsScript.async = true;
      partsScript.src = selfSrc.replace(/hs-preorder\.js(\?[^#]*)?/, 'hs-parts.js?v=961cbaf3d0d7');
      document.head.appendChild(partsScript);
    }
  } catch (e) { /* the status block is optional; pre-orders are not */ }

  var preorderData     = window.__HS_PREORDER || {};
  var preorderKeys     = Object.keys(preorderData);
  var product          = null;
  var currentVariantId = null;
  var _applying        = false;
  var _burstTimer      = null;
  var _styleInjected   = false;

  // ── Per-shop settings (fetched from the app's /api/storefront-settings) ──
  // Defaults match the server's STOREFRONT_DEFAULTS so the storefront still
  // renders if the API is unreachable. Replaced after fetch completes.
  var _settings = {
    button_text:         'Передзамовлення',
    corner_tag:          'Передзамовлення',
    notice_text:         'Це передзамовлення: відправка близько {{eta}}. Напишемо, щойно посилка виїде. Гарантія рік і безкоштовний обмін розміру діють як завжди.',
    property_label:      'Передзамовлення',
    property_text:       'Відправка близько {{eta}} — дата приблизна, може зсунутись на кілька днів.',
    date_format:         'uk',
    color_primary:       '#C9A192',
    language:            'uk',
    show_corner_tag:     1,
    show_notice:         1,
    show_stock_count:    0,
    max_qty_per_order:   0,
    cart_warning_text:   'У кошику є передзамовлення, тому все замовлення відправимо однією посилкою — близько {{eta}}, коли надійдуть усі речі.',
    // Tickbox: off until the server says the split switch is on.
    split_enabled:       0,
    split_on_text:       'Відправимо двома посилками: те, що є в наявності, — одразу, передзамовлення — близько {{eta}}.',
    split_label_text:    'Відправити частинами: те, що є в наявності, — одразу',
    split_note_text:     'Передзамовлення прийде окремим замовленням і посилкою. Доставку кожної посилки оплачуємо ми.',
    // Cash on delivery is available for pre-orders: no COD line unless the server sends one.
    cod_warning_enabled: 0,
    cod_warning_text:    '',
    // Site-wide notice strip: disabled by default on the client so it only
    // ever appears when the server explicitly says so with fresh text.
    war_notice_enabled:    0,
    war_notice_text:       '',
    // One line shown after the popup; «Детальніше» expands war_notice_text.
    war_notice_short_text: 'Після пожежі на складі — знову відправляємо.',
    war_notice_ig_url:     'https://instagram.com/holyshapeua',
    war_notice_portal_url: 'https://vip.holyshapeua.com/portal',
    // Loyalty strip — the one line on the site that says the cashback and the
    // portal exist. Off until the server says otherwise, like the notice above.
    loyalty_notice_enabled: 0,
    loyalty_notice_text:    '',
    loyalty_notice_cta:     'Мій кабінет →',
    loyalty_notice_url:     'https://vip.holyshapeua.com/portal/login?src=site',
    custom_css:          '',
    // «Доставка й оплата» block: null until the server sends it (hs-delivery-block).
    delivery_block:      null,
  };
  var _defaultSettings = JSON.parse(JSON.stringify(_settings));
  var _settingsLoaded = false;
  var _customCssInjected = false;

  function injectCustomCss() {
    if (_customCssInjected) {
      var prior = document.getElementById('hs-po-custom-css');
      if (prior) prior.parentNode && prior.parentNode.removeChild(prior);
      _customCssInjected = false;
    }
    if (!_settings.custom_css || !_settings.custom_css.trim()) return;
    var s = document.createElement('style');
    s.id = 'hs-po-custom-css';
    s.textContent = _settings.custom_css;
    document.head.appendChild(s);
    _customCssInjected = true;
  }

  // ── Site-wide notice (war / delivery disruptions) ────────────────────────
  // First contact is a centered popup — impossible to scroll past. Closing it
  // is remembered per message text, and from then on the same message lives
  // as the slim banner above the header (with its own 24h dismiss). A CHANGED
  // message starts the cycle again from the popup.
  function noticeHash(t) {
    var h = 0;
    for (var i = 0; i < t.length; i++) h = ((h << 5) - h + t.charCodeAt(i)) | 0;
    return String(h);
  }
  var IG_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2.5" y="2.5" width="19" height="19" rx="5"/><circle cx="12" cy="12" r="4.2"/><circle cx="17.3" cy="6.7" r="1.2" fill="currentColor" stroke="none"/></svg>';
  var USER_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4.5 21c0-4 3.4-6.3 7.5-6.3s7.5 2.3 7.5 6.3"/></svg>';
  function noticeLink(href, label, svg, block) {
    var a = document.createElement('a');
    a.href = href; a.target = '_blank'; a.rel = 'noopener';
    a.setAttribute('aria-label', label);
    a.style.cssText = block
      ? 'display:flex;align-items:center;justify-content:center;gap:7px;color:#fbbf24;border:1px solid rgba(251,191,36,.45);' +
        'text-decoration:none;min-height:44px;font-weight:600;border-radius:12px;font-size:14px;'
      : 'display:inline-flex;align-items:center;gap:5px;color:#fbbf24;' +
        'text-decoration:underline;min-height:40px;white-space:nowrap;font-weight:600;';
    a.innerHTML = svg + '<span>' + label + '</span>';
    return a;
  }
  function igUrl() { return _settings.war_notice_ig_url || 'https://instagram.com/holyshapeua'; }
  function portalUrl() { return _settings.war_notice_portal_url || 'https://vip.holyshapeua.com/portal'; }

  // Where she is buying: product page, cart, checkout. A full-screen notice
  // here costs a dismissal and a decision at the moment she is deciding to buy
  // — measured 3–6 s on a phone (owner, 20.09.2026). The message is not
  // weakened, it is delivered as the one-line bar instead.
  function onBuyingPath() {
    var p = String(window.location.pathname || '').toLowerCase();
    return p.indexOf('/products/') !== -1 || /(^|\/)cart(\/|$)/.test(p) || p.indexOf('/checkout') !== -1;
  }

  function renderNoticeBanner() {
    var text = String(_settings.war_notice_text || '').trim();
    var enabled = Number(_settings.war_notice_enabled) && text;
    var priorBar = document.getElementById('hs-war-notice');
    var priorPop = document.getElementById('hs-war-notice-pop');
    // Same message already on screen (cached settings rendered it): leave it,
    // re-inserting would make the page jump.
    var shown = priorBar || priorPop;
    if (enabled && shown && shown.getAttribute('data-h') === noticeHash(text + '|' + (_settings.war_notice_short_text || ''))) return;
    if (priorBar && priorBar.parentNode) priorBar.parentNode.removeChild(priorBar);
    if (priorPop && priorPop.parentNode) priorPop.parentNode.removeChild(priorPop);
    if (!enabled) return;

    var popKey = 'hs-war-notice-popup';
    var popupSeen = false;
    try {
      var seen = JSON.parse(localStorage.getItem(popKey) || 'null');
      popupSeen = !!(seen && seen.h === noticeHash(text));
    } catch (e) { popupSeen = true; }   // storage broken → never trap in a popup loop

    if (!popupSeen && !onBuyingPath()) showNoticePopup(text, popKey);
    else showNoticeBar(text);
  }

  function showNoticePopup(text, popKey) {
    var overlay = document.createElement('div');
    overlay.id = 'hs-war-notice-pop';
    overlay.setAttribute('data-h', noticeHash(text + '|' + (_settings.war_notice_short_text || '')));
    overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.62);' +
      'display:flex;align-items:center;justify-content:center;padding:20px;';

    var card = document.createElement('div');
    card.style.cssText = 'background:#1f2937;color:#f9fafb;border-radius:18px;max-width:420px;width:100%;' +
      'padding:26px 22px 20px;box-shadow:0 30px 80px -20px rgba(0,0,0,.8);text-align:center;' +
      'font-size:14.5px;line-height:1.55;max-height:88vh;overflow:auto;';

    var dove = document.createElement('div');
    dove.textContent = '🕊';
    dove.style.cssText = 'font-size:34px;margin-bottom:10px;';
    card.appendChild(dove);

    var msg = document.createElement('p');
    msg.textContent = text;
    msg.style.cssText = 'margin:0 0 16px;';
    card.appendChild(msg);

    var btns = document.createElement('div');
    btns.style.cssText = 'display:flex;flex-direction:column;gap:9px;';
    // «Напишіть нам» is gone from the popup (owner, 20.09.2026): a notice about
    // the fire that opens with an invitation to write reads as «something went
    // wrong, complain here», and it led out of the shop into Instagram. The
    // order-status link stays — that is the question this notice actually
    // raises. The expanded bar still carries both.
    btns.appendChild(noticeLink(portalUrl(), 'Статус замовлення', USER_SVG, true));
    card.appendChild(btns);

    var ok = document.createElement('button');
    ok.type = 'button';
    ok.textContent = 'Зрозуміло 🤍';
    ok.style.cssText = 'margin-top:12px;width:100%;background:#fbbf24;color:#1f2937;border:none;' +
      'border-radius:12px;padding:13px;font-weight:700;font-size:14.5px;cursor:pointer;';
    var closePopup = function () {
      try { localStorage.setItem(popKey, JSON.stringify({ h: noticeHash(text), at: Date.now() })); } catch (e) {}
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      showNoticeBar(text);   // the message stays present, just smaller
    };
    ok.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    card.appendChild(ok);

    overlay.appendChild(card);
    if (document.body) document.body.appendChild(overlay);
  }

  function showNoticeBar(text) {
    if (document.getElementById('hs-war-notice')) return;
    var key = 'hs-war-notice-dismissed';
    try {
      var saved = JSON.parse(localStorage.getItem(key) || 'null');
      if (saved && saved.h === noticeHash(text) && Date.now() - saved.at < 24 * 3600 * 1000) return;
    } catch (e) {}

    // After the popup has been read, the message stays as ONE line with
    // «Детальніше» (owner, 2026-09-17): the full 7-line bar took a quarter of
    // a phone screen on every page. Tapping expands the full text and links.
    var bar = document.createElement('div');
    bar.id = 'hs-war-notice';
    bar.setAttribute('data-h', noticeHash(text + '|' + (_settings.war_notice_short_text || '')));
    bar.style.cssText = 'position:relative;z-index:60;background:#1f2937;color:#f9fafb;' +
      'font-size:13px;line-height:1.45;padding:7px 40px 7px 14px;text-align:center;box-sizing:border-box;';

    // Text and «Детальніше» flow as one paragraph, so the collapsed bar is a
    // single line where it fits and two short lines on a narrow phone.
    var line = document.createElement('div');
    line.style.cssText = 'max-width:760px;margin:0 auto;';
    var msg = document.createElement('span');
    msg.textContent = '🕊 ' + (_settings.war_notice_short_text || text);
    line.appendChild(msg);
    bar.appendChild(line);

    var links = document.createElement('div');
    links.style.cssText = 'display:none;align-items:center;justify-content:center;gap:14px;flex-wrap:wrap;';
    links.appendChild(noticeLink(igUrl(), 'Напишіть нам', IG_SVG, false));
    links.appendChild(noticeLink(portalUrl(), 'Статус замовлення', USER_SVG, false));

    var more = document.createElement('button');
    more.type = 'button';
    more.textContent = 'Детальніше';
    more.setAttribute('aria-expanded', 'false');
    more.style.cssText = 'background:none;border:none;color:#fbbf24;font:inherit;font-weight:600;' +
      'text-decoration:underline;text-underline-offset:3px;cursor:pointer;padding:0 0 0 6px;margin:0;';
    more.addEventListener('click', function () {
      msg.textContent = '🕊 ' + text;
      links.style.display = 'flex';
      if (more.parentNode) more.parentNode.removeChild(more);
    });
    if (_settings.war_notice_short_text) line.appendChild(more);
    else links.style.display = 'flex';
    bar.appendChild(links);

    var x = document.createElement('button');
    x.type = 'button';
    x.setAttribute('aria-label', 'Закрити');
    x.textContent = '×';
    x.style.cssText = 'position:absolute;top:50%;right:4px;transform:translateY(-50%);' +
      'background:none;border:none;color:#9ca3af;font-size:22px;line-height:1;cursor:pointer;padding:8px 10px;';
    x.addEventListener('click', function () {
      try { localStorage.setItem(key, JSON.stringify({ h: noticeHash(text), at: Date.now() })); } catch (e) {}
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    });
    bar.appendChild(x);

    if (document.body) document.body.insertBefore(bar, document.body.firstChild);
  }

  // Thin strip under the notice bar (or at the very top when the notice is
  // off). Dismissable for a day; the text hash keys the dismissal so new copy
  // shows again. Nothing here is a popup — it is a reminder, not an alarm.
  function renderLoyaltyBar() {
    var prior = document.getElementById('hs-loyalty-notice');
    if (prior && prior.parentNode) prior.parentNode.removeChild(prior);
    var text = String(_settings.loyalty_notice_text || '').trim();
    if (!Number(_settings.loyalty_notice_enabled) || !text) return;
    var key = 'hs-loyalty-notice-dismissed';
    try {
      var saved = JSON.parse(localStorage.getItem(key) || 'null');
      if (saved && saved.h === noticeHash(text) && Date.now() - saved.at < 24 * 3600 * 1000) return;
    } catch (e) {}

    var bar = document.createElement('div');
    bar.id = 'hs-loyalty-notice';
    bar.style.cssText = 'position:relative;z-index:59;background:#fbf3e6;color:#3b2f22;' +
      'font-size:13px;line-height:1.45;padding:8px 40px 8px 14px;display:flex;flex-wrap:wrap;' +
      'align-items:center;justify-content:center;gap:4px 14px;text-align:center;';

    var msg = document.createElement('span');
    msg.textContent = text;
    bar.appendChild(msg);

    var a = document.createElement('a');
    a.href = _settings.loyalty_notice_url || 'https://vip.holyshapeua.com/portal/login?src=site';
    a.textContent = _settings.loyalty_notice_cta || 'Мій кабінет →';
    a.style.cssText = 'color:#3b2f22;font-weight:700;text-decoration:underline;text-underline-offset:3px;white-space:nowrap;';
    bar.appendChild(a);

    var x = document.createElement('button');
    x.type = 'button';
    x.setAttribute('aria-label', 'Закрити');
    x.textContent = '×';
    x.style.cssText = 'position:absolute;top:50%;right:4px;transform:translateY(-50%);' +
      'background:none;border:none;color:#9a8a76;font-size:20px;line-height:1;cursor:pointer;padding:6px 10px;';
    x.addEventListener('click', function () {
      try { localStorage.setItem(key, JSON.stringify({ h: noticeHash(text), at: Date.now() })); } catch (e) {}
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    });
    bar.appendChild(x);

    if (!document.body) return;
    var war = document.getElementById('hs-war-notice');
    if (war && war.parentNode === document.body) document.body.insertBefore(bar, war.nextSibling);
    else document.body.insertBefore(bar, document.body.firstChild);
  }
  // Settings are cached in localStorage: a returning page renders the notice
  // bar and styles immediately instead of ~0.4–1.4 s later (the late bar pushed
  // the whole page down — CLS). The network copy still wins when it differs.
  var SETTINGS_CACHE_KEY = 'hs-po-settings-v1';
  var SETTINGS_CACHE_MAX_AGE = 7 * 24 * 3600 * 1000;

  function mergeSettings(json) {
    if (!json || typeof json !== 'object') return;
    for (var k in _settings) {
      if (json[k] !== undefined && json[k] !== null && json[k] !== '') {
        _settings[k] = json[k];
      }
    }
  }

  function applySettingsUi() {
    _settingsLoaded = true;
    // Re-inject CSS so the new color_primary + corner_tag take effect
    _pickerStyleInjected = false;
    injectPickerStyles();
    injectCustomCss();
    // Cart-side UX (COD warning banner, per-line cart warnings,
    // quantity caps) needs to react to settings + cart state.
    setupCartUI();
    renderNoticeBanner();
    renderLoyaltyBar();
    dlvDraw();
  }

  function fetchSettings(cb) {
    var url = window.__HS_PREORDER_SETTINGS_API;
    if (!url) { _settingsLoaded = true; if (cb) cb(); return; }

    var cachedRaw = null;
    try {
      var cached = JSON.parse(localStorage.getItem(SETTINGS_CACHE_KEY) || 'null');
      if (cached && cached.at && Date.now() - cached.at < SETTINGS_CACHE_MAX_AGE && cached.json) {
        cachedRaw = JSON.stringify(cached.json);
        mergeSettings(cached.json);
        applySettingsUi();
      }
    } catch (e) { cachedRaw = null; }
    var started = !!cachedRaw;
    if (started && cb) cb();

    var finish = function () {
      if (started) return;
      started = true;
      _settingsLoaded = true;
      if (cb) cb();
    };
    try {
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (!json || typeof json !== 'object') return finish();
          var raw = JSON.stringify(json);
          try { localStorage.setItem(SETTINGS_CACHE_KEY, JSON.stringify({ at: Date.now(), json: json })); } catch (e) {}
          if (raw !== cachedRaw) {
            // Start from the defaults so a value the server cleared does not
            // survive from the cached copy.
            for (var d in _defaultSettings) _settings[d] = _defaultSettings[d];
            mergeSettings(json);
            applySettingsUi();
          }
          finish();
        })
        .catch(function (e) {
          console.warn('[PreorderPro] settings fetch failed, using defaults:', e);
          finish();
        });
    } catch (e) {
      finish();
    }
  }

  // ── Inject CSS once ───────────────────────────────────────────────────────
  // Strategy: hide EVERY descendant of the marked button with visibility:hidden
  // (preserves layout — spinners still take up their reserved space) and
  // overlay our .hs-po-label absolutely-positioned on top, centered. This
  // wins regardless of how the theme nests / restores / pseudo-elements its
  // own text.
  function injectStyles() {
    if (_styleInjected) return;
    var style = document.createElement('style');
    // The label text is rendered by a ::after pseudo-element whose content
    // comes from data-hs-po-text on the button. Themes can't access pseudo
    // elements via JS, so they can't overwrite our text on variant change.
    style.textContent = [
      'button[data-hs-preorder="true"] {',
      '  position: relative !important;',
      '  color: transparent !important;',  /* hides theme text via inheritance */
      '  text-shadow: none !important;',
      '}',
      // Hide direct children (theme's wrapped text spans, icons, etc.).
      'button[data-hs-preorder="true"] > * {',
      '  visibility: hidden !important;',
      '}',
      // Render OUR label as a pseudo-element on the button. content comes
      // from the data-hs-po-text attribute we set via JS.
      'button[data-hs-preorder="true"]::after {',
      '  content: attr(data-hs-po-text) !important;',
      '  position: absolute !important;',
      '  top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  text-align: center !important;',
      '  visibility: visible !important;',
      '  color: var(--hs-po-color, #fff) !important;',
      '  font-size: var(--hs-po-font-size, 1em) !important;',
      '  font-weight: inherit !important;',
      '  line-height: 1.15 !important;',
      '  letter-spacing: normal !important;',
      '  text-indent: 0 !important;',
      '  text-shadow: none !important;',
      '  z-index: 10 !important;',
      '  pointer-events: none !important;',
      '  white-space: normal !important;',         /* allow wrap for long text */
      '  word-break: normal !important;',
      '  overflow-wrap: break-word !important;',
      '  overflow: hidden !important;',
      '  padding: 4px 10px !important;',
      '  box-sizing: border-box !important;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
    _styleInjected = true;
  }

  // Set the button's data-hs-po-text + --hs-po-color so the ::after
  // pseudo-element renders our label in the captured original color.
  // Also dials --hs-po-font-size down for long copy (e.g. Ukrainian
  // "Preorder - Предзамовлення – відправка буде [date]") so the text
  // fits without aggressive truncation.
  // Ink for text drawn over the accent: dark on a light metal, white on a
  // dark one. Rose Gold (#C9A192) takes the dark ink at 8:1.
  function inkFor(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length !== 6) return '#ffffff';
    var r = parseInt(h.substr(0, 2), 16) / 255, g = parseInt(h.substr(2, 2), 16) / 255, b = parseInt(h.substr(4, 2), 16) / 255;
    var f = function (v) { return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    var lum = 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
    return lum > 0.35 ? '#1A1417' : '#ffffff';
  }
  function accentColor() { return _settings.color_primary || '#C9A192'; }
  // Legend and notice text sit on white: a darker relative of the accent that
  // clears 4.5:1, so the metal marks meaning and the words stay readable.
  var LEGEND_INK = '#6B4F45';

  function setOverlayText(btn, text, color) {
    if (!btn) return;
    btn.setAttribute('data-hs-po-text', text);
    // The drawn label is a pseudo-element; the accessible name must say the same.
    btn.setAttribute('aria-label', text);
    btn.setAttribute('data-hs-po-aria', '1');
    if (color) btn.style.setProperty('--hs-po-color', color, 'important');
    var len = (text || '').length;
    var fontSize = '1em';
    if (len > 60)      fontSize = '0.72em';
    else if (len > 45) fontSize = '0.8em';
    else if (len > 30) fontSize = '0.9em';
    btn.style.setProperty('--hs-po-font-size', fontSize, 'important');
  }

  // Re-clear the button on the next animation frame if the theme re-renders
  // its inner text (some themes restore the label after variant changes).
  // Throttled to one observer per button.
  function guardButtonText(btn) {
    if (!btn || btn.__hsPoGuarded) return;
    btn.__hsPoGuarded = true;
    var observer = new MutationObserver(function () {
      // Schedule once per frame
      if (btn.__hsPoPending) return;
      btn.__hsPoPending = true;
      requestAnimationFrame(function () {
        btn.__hsPoPending = false;
        if (btn.getAttribute('data-hs-preorder') !== 'true') return;
        blankAllDescendantText(btn, '.hs-po-label');
      });
    });
    observer.observe(btn, { childList: true, subtree: true, characterData: true });
  }

  // Walk every text node inside `rootEl` and blank it, EXCEPT nodes inside
  // any element matching `keepSelector` (e.g. '.hs-po-label'). Used to wipe
  // the theme's original "Add to cart" text wherever it's hiding — deep
  // nested spans, divs, whatever — without touching ours.
  function blankAllDescendantText(rootEl, keepSelector) {
    if (!rootEl) return;
    var toClear = [];
    var walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (!node.textContent.trim()) continue;
      var inside = false;
      var p = node.parentElement;
      while (p && p !== rootEl) {
        if (p.matches && p.matches(keepSelector)) { inside = true; break; }
        p = p.parentElement;
      }
      if (!inside) toClear.push(node);
    }
    toClear.forEach(function (n) { n.textContent = ''; });
  }

  // ── Hide the theme's conflicting sold-out / "notify me" UI ────────────────
  // When a variant is in pre-order mode the theme still shows its native
  // "Sold out" badge, "already sold out" message and a back-in-stock "Notify
  // me when available" button — all of which contradict the pre-order CTA.
  // Hide them while pre-order is active, scoped to the product area, and
  // restore them when the variant is no longer pre-order. Fully reversible.
  var _hiddenConflicts = [];
  var _conflictBtn = null;            // last button we hid conflicts around
  function productScopeFor(btn) {
    var scope = btn && btn.closest(
      'product-info, .product-info, [class*="product-info"], [class*="product__info"], ' +
      '[class*="product-form"], .product, main, [role="main"]'
    );
    return scope || document.body;
  }
  function hideConflictEl(el) {
    if (!el || el.getAttribute('data-hs-po-hidden') === '1') return;
    // Never hide our own button or any ancestor that contains it.
    if (el.getAttribute('data-hs-preorder') === 'true') return;
    if (el.querySelector && el.querySelector('[data-hs-preorder="true"], #hs-preorder-notice')) return;
    el.__hsPoPrevDisplay = el.style.display;
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute('data-hs-po-hidden', '1');
    _hiddenConflicts.push(el);
  }
  // Visible-text patterns for the conflicting UI, English + Ukrainian (this is
  // a Debutify theme that ships both locales). The notify button text in the
  // wild has shown up in English even on the UA storefront, so match both.
  var NOTIFY_TEXT_RE  = /notify me|back in stock|when it.?s? available|email me when|notify when|повідом|сповіст|уведом|сообщит/i;
  var SOLDOUT_TEXT_RE = /already sold out|no longer available|is sold out|out of stock|sold out|немає в наявності|розпродано|нема в наявності|распродано|распродан|нет в наличии|уже распродан/i;

  function setPreorderConflictsHidden(hidden, btn) {
    if (!hidden) {
      _conflictBtn = null;
      _hiddenConflicts.forEach(function (el) {
        if (el.__hsPoPrevDisplay) el.style.display = el.__hsPoPrevDisplay;
        else el.style.removeProperty('display');
        el.removeAttribute('data-hs-po-hidden');
        el.__hsPoPrevDisplay = undefined;
      });
      _hiddenConflicts = [];
      return;
    }
    _conflictBtn = btn || _conflictBtn;
    var scope = productScopeFor(btn);

    // 1) Back-in-stock / notify widgets by class or id
    scope.querySelectorAll(
      '[class*="back-in-stock"],[class*="back_in_stock"],[class*="backinstock"],' +
      '[class*="notify"],[class*="restock"],[id*="back-in-stock"],[id*="BackInStock"],[id*="notify"]'
    ).forEach(hideConflictEl);

    // 2) Notify buttons identified by their visible text
    scope.querySelectorAll('button, a, [role="button"], input[type="submit"]').forEach(function (el) {
      var t = (el.value || el.textContent || '').trim();
      if (!t || t.length > 80) return;
      if (NOTIFY_TEXT_RE.test(t)) {
        hideConflictEl(el.closest('form, [class*="notify"], [class*="back-in-stock"]') || el);
      }
    });

    // 3) Sold-out / unavailable badges + short inline messages
    scope.querySelectorAll(
      '[class*="sold-out"],[class*="soldout"],[class*="sold_out"],' +
      '[class*="unavailable"],[class*="out-of-stock"],[class*="out_of_stock"]'
    ).forEach(hideConflictEl);
    scope.querySelectorAll('p, span, small, div, strong, b').forEach(function (el) {
      if (el.children.length > 2) return;            // skip big containers
      var t = (el.textContent || '').trim();
      if (!t || t.length > 120) return;
      if (SOLDOUT_TEXT_RE.test(t)) hideConflictEl(el);
    });

    // 4) Dynamic checkout buttons (Buy it now / Shop Pay) bypass the cart and
    //    our pre-order line-item properties, so hide them while pre-order is on.
    scope.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(hideConflictEl);
  }

  // Re-run the hide pass (the theme/app injects the notify button + sold-out
  // badge asynchronously, so a one-shot hide loses the race). Called from the
  // global DOM observer while a pre-order variant is active.
  function reapplyConflictHideIfActive() {
    if (!_conflictBtn) return;
    if (_conflictBtn.getAttribute('data-hs-preorder') !== 'true') return;
    setPreorderConflictsHidden(true, _conflictBtn);
  }

  // ── Variant picker decoration ─────────────────────────────────────────────
  // Adds a small Holy Shape-themed "PRE-ORDER" corner badge to any variant
  // picker button (size swatch, color swatch, dropdown option) whose underlying
  // variant is currently pre-order. Buy-button behavior is unchanged — this is
  // purely a hint for the picker so customers don't have to click through every
  // option to find pre-order ones.
  var _pickerStyleInjected = false;
  // Lighten a #rrggbb hex color by mixing it with white. Used so the corner
  // tag has a slight gradient even when the merchant picks a single solid color.
  function lighten(hex, amount) {
    var h = String(hex || '#b8865e').replace('#','');
    if (h.length !== 6) return hex;
    var r = parseInt(h.substr(0,2),16), g = parseInt(h.substr(2,2),16), b = parseInt(h.substr(4,2),16);
    r = Math.min(255, Math.round(r + (255 - r) * amount));
    g = Math.min(255, Math.round(g + (255 - g) * amount));
    b = Math.min(255, Math.round(b + (255 - b) * amount));
    return '#' + [r,g,b].map(function(v){ return v.toString(16).padStart(2,'0'); }).join('');
  }
  // CSS-safe escape for the corner tag content (it's user-typed).
  function cssEscapeContent(s) {
    return String(s || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }
  var CLOCK_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none' stroke='%231A1417' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='10' cy='10' r='7'/%3E%3Cpath d='M10 6.2v4l2.6 1.6'/%3E%3C/svg%3E";
  var CHECK_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none' stroke='%23ffffff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 10.5l3.5 3.5L15 7'/%3E%3C/svg%3E";
  var CROSS_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none' stroke='%238A7A74' stroke-width='2.2' stroke-linecap='round'%3E%3Cpath d='M6.5 6.5l7 7M13.5 6.5l-7 7'/%3E%3C/svg%3E";

  // One stylesheet for everything the script draws: the clock on a pill, the
  // legend card under the sizes, the notice under the button, the cart banner.
  // Rose Gold marks meaning; the words sit in ink on a pale tint of it.
  function injectPickerStyles() {
    if (_pickerStyleInjected) return;
    var prior = document.getElementById('hs-po-picker-styles');
    if (prior) prior.parentNode && prior.parentNode.removeChild(prior);
    var s = document.createElement('style');
    s.id = 'hs-po-picker-styles';
    var color = accentColor();
    var tint = lighten(color, 0.84);
    var line = lighten(color, 0.45);
    var showTag = _settings.show_corner_tag !== 0 && _settings.show_corner_tag !== false;
    var clock = 'background: ' + color + ' url("' + CLOCK_SVG + '") center / 12px 12px no-repeat';
    s.textContent = [
      '[data-hs-po-variant="1"] { position: relative !important; box-shadow: inset 0 0 0 1.5px ' + color + ' !important; }',
      (showTag ? '[data-hs-po-variant="1"]::after' : '[data-hs-po-variant="1"][data-tag-disabled]::after') + ' {',
      '  content: ""; position: absolute; top: -7px; right: -7px; width: 18px; height: 18px; box-sizing: border-box;',
      '  ' + clock + '; border: 2px solid #fff; border-radius: 50%; pointer-events: none; z-index: 3;',
      '}',
      '.hs-po-legend { display: grid; gap: 7px; width: 100%; box-sizing: border-box; margin: 10px 0 4px; padding: 11px 13px; background: ' + tint + '; border: 1px solid ' + line + '; border-radius: 12px; font-size: 13px; line-height: 1.4; color: ' + LEGEND_INK + '; font-weight: 500; text-align: left; letter-spacing: 0; text-transform: none; }',
      '.hs-po-legend__row { display: flex; gap: 8px; align-items: flex-start; }',
      // A flex child will not shrink below its longest word by default, and
      // «Передзамовлення:» is wider than a 2-column card allows — 4px of the
      // row hung outside the box on phones until this let it wrap.
      '.hs-po-legend__row > span:last-child { min-width: 0; overflow-wrap: anywhere; }',
      '.hs-po-legend__ic { flex: 0 0 16px; width: 16px; height: 16px; margin-top: 1px; border-radius: 50%; box-sizing: border-box; }',
      '.hs-po-legend__ic--po { ' + clock.replace('12px 12px', '11px 11px') + '; }',
      '.hs-po-legend__ic--ok { background: #7FB08D url("' + CHECK_SVG + '") center / 11px 11px no-repeat; }',
      '.hs-po-legend__ic--no { background: #EBE4E1 url("' + CROSS_SVG + '") center / 11px 11px no-repeat; }',
      '.hs-po-legend b { font-weight: 700; color: #2B211E; }',
      '.hs-po-legend__row--no { color: #8A7A74; }',
      '#hs-preorder-notice { display: flex; gap: 10px; align-items: flex-start; box-sizing: border-box; width: 100%; margin: 10px 0 0; padding: 12px 14px; background: ' + tint + '; border: 1px solid ' + line + '; border-radius: 12px; font-size: 14px; line-height: 1.45; color: #2B211E; text-align: left; white-space: normal; font-weight: 500; }',
      '#hs-preorder-notice .hs-po-legend__ic { margin-top: 2px; }',
      '.hs-po-cart-banner { display: flex; gap: 10px; align-items: flex-start; box-sizing: border-box; width: 100%; margin: 0 0 12px; padding: 12px 14px; background: ' + tint + '; border: 1px solid ' + line + '; border-radius: 12px; font-size: 14px; line-height: 1.45; color: #2B211E; text-align: left; font-weight: 500; }',
      '.hs-po-cart-banner p { margin: 0; }',
      '.hs-po-cart-banner p + p { margin-top: 6px; }',
      // The tickbox row. Themes restyle or hide native checkboxes, so this one
      // is put back explicitly; the whole row is the 44px tap target.
      '.hs-po-split { display: flex !important; gap: 10px; align-items: flex-start; min-height: 44px; box-sizing: border-box; margin: 10px 0 0; padding: 10px 0 0; border-top: 1px solid ' + line + '; cursor: pointer; font-size: 14px; line-height: 1.4; font-weight: 600; color: #2B211E; text-transform: none; letter-spacing: 0; }',
      '.hs-po-split input[type="checkbox"] { -webkit-appearance: checkbox !important; appearance: auto !important; position: static !important; opacity: 1 !important; display: inline-block !important; flex: 0 0 20px; width: 20px !important; height: 20px !important; margin: 0 !important; accent-color: #2B211E; cursor: pointer; }',
      '.hs-po-split small { display: block; margin-top: 3px; font-size: 13px; font-weight: 500; line-height: 1.4; color: ' + LEGEND_INK + '; }',
      // The custom collection-card SECTION ships its own ribbon rule
      // (.size-pill.pill-preorder::after with the full corner_tag word) —
      // theme-owned CSS this script cannot edit, only outrank.
      '.size-pill.pill-preorder { box-shadow: inset 0 0 0 1.5px ' + color + ' !important; position: relative !important; }',
      '.size-pill.pill-preorder::after {',
      showTag ? '  content: "" !important;' : '  content: none !important;',
      '  position: absolute !important; top: -7px !important; right: -7px !important; left: auto !important; bottom: auto !important;',
      '  width: 18px !important; height: 18px !important; padding: 0 !important; margin: 0 !important; box-sizing: border-box !important;',
      '  ' + clock + ' !important; border: 2px solid #fff !important; border-radius: 50% !important;',
      '  pointer-events: none !important; z-index: 3 !important; box-shadow: none !important;',
      '}',
    ].join('\n');
    document.head.appendChild(s);
    _pickerStyleInjected = true;
  }

  // Extract only the visible text of an element, ignoring screen-reader prefixes
  // (e.g. .visually-hidden / .sr-only / [aria-hidden] / inputs).
  function visibleText(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    clone.querySelectorAll(
      '.visually-hidden, .sr-only, .screen-reader-text, .visuallyhidden, ' +
      '[aria-hidden="true"], input, select, .hs-po-variant-badge'
    ).forEach(function (n) { n.parentNode && n.parentNode.removeChild(n); });
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Does this element's visible text reference the given option value?
  // Handles "Size: XS/S", "XS/S Size", trailing colon, etc.
  function textMentionsValue(text, value) {
    if (!text || !value) return false;
    var t = text.toLowerCase().trim();
    var v = String(value).toLowerCase().trim();
    if (!t || !v) return false;
    if (t === v) return true;
    // Equal after stripping common label prefixes ("Size: ", "Color: ")
    var stripped = t.replace(/^[a-z][a-z\s]*:\s*/i, '').trim();
    if (stripped === v) return true;
    // The value appears as a standalone token
    var re = new RegExp('(?:^|[\\s:\\/])' + v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:$|[\\s:\\/])');
    return re.test(t);
  }

  // Normalize an option name regardless of which Shopify response shape we got:
  //   legacy:  'Size'
  //   modern:  { name: 'Size', values: [...] }
  function optionNameOf(o) {
    if (!o) return '';
    if (typeof o === 'string') return o;
    if (typeof o.name === 'string') return o.name;
    if (typeof o.option === 'string') return o.option;
    return '';
  }

  // Try every reasonable way to find the picker control for a given option
  // value (and the variant it would resolve to). Returns the clickable element.
  function findPickerEl(optionName, value, optionIndex, variantId) {
    var lowName = optionNameOf(optionName).toLowerCase();
    var trimVal = String(value || '').trim();
    if (!trimVal) return null;

    // 0) HIGHEST PRIORITY — picker elements that already declare the variant ID
    if (variantId) {
      var vidSel = [
        '[data-variant-id="' + variantId + '"]',
        '[data-product-variant-id="' + variantId + '"]',
        'a[href*="variant=' + variantId + '"]',
      ];
      for (var v = 0; v < vidSel.length; v++) {
        var matches = document.querySelectorAll(vidSel[v]);
        for (var mi = 0; mi < matches.length; mi++) {
          var ve = matches[mi];
          // Debutify's <pickup-availability data-variant-id> and the form's own
          // hidden id input also carry the variant id; neither is a size pill.
          if (ve.closest('pickup-availability, form[action*="/cart/add"] input[name="id"], [data-hs-preorder]')) continue;
          if (ve.matches('input[name="id"], select, option')) continue;
          // Prefer a clickable ancestor (label or button) over a raw <input>
          var clickable = ve.closest('label, button, .swatch, [role="button"]');
          if (clickable && clickable.matches('[name="add"], [type="submit"]')) continue;
          return clickable || ve;
        }
      }
    }

    // 1) Native radio inputs whose value matches and whose name relates to the option
    var radios = document.querySelectorAll(
      'input[type="radio"][value="' + cssEscape(trimVal) + '"]'
    );
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var n = (r.name || '').toLowerCase();
      if (!lowName || n.indexOf(lowName) !== -1 || n === '' || n.indexOf('option') !== -1) {
        var lab = r.closest('label');
        if (lab) return lab;
        if (r.id) {
          var external = document.querySelector('label[for="' + cssEscape(r.id) + '"]');
          if (external) return external;
        }
        return r;
      }
    }

    // 2) Buttons or labels with data attributes
    var dataSelectors = [
      '[data-option-value="' + cssEscape(trimVal) + '"]',
      '[data-value="' + cssEscape(trimVal) + '"]',
      '[data-variant-option-value="' + cssEscape(trimVal) + '"]',
      '[data-option-' + (optionIndex + 1) + '="' + cssEscape(trimVal) + '"]',
    ];
    for (var k = 0; k < dataSelectors.length; k++) {
      var el = document.querySelector(dataSelectors[k]);
      if (el) return el.closest('label, button, .swatch, [role="button"]') || el;
    }

    // 3) Fallback — find any button/label whose VISIBLE text mentions the value.
    //    Strips screen-reader prefixes like "Size: " or "Variant: ".
    //    We score candidates so the tightest match wins.
    var allClickables = document.querySelectorAll('button, label, .swatch, [role="button"]');
    var best = null;
    var bestScore = 0;
    for (var j = 0; j < allClickables.length; j++) {
      var c = allClickables[j];
      // Skip our own buy button to avoid re-decorating it
      if (c.getAttribute('data-hs-preorder') === 'true') continue;
      if (c.getAttribute('data-hs-po-variant') === '1' && c.__hsPoValue !== trimVal) continue;
      var txt = visibleText(c);
      if (!textMentionsValue(txt, trimVal)) continue;
      // Score: prefer exact match, then ancestor that mentions the option name
      var score = 1;
      if (txt.toLowerCase() === trimVal.toLowerCase()) score += 5;
      var fs = c.closest('fieldset, .product-form__input, .variant-picker, .product-options, ' +
                         '[class*="variant-input"], [class*="option-selector"], [class*="swatch"]');
      if (fs && lowName) {
        var legendText = '';
        var legend = fs.querySelector('legend, .product-form__label, .form__label, label');
        if (legend) legendText = legend.textContent.toLowerCase();
        if (legendText.indexOf(lowName) !== -1) score += 3;
      }
      if (score > bestScore) { best = c; bestScore = score; }
    }
    if (best) return best;

    return null;
  }

  function cssEscape(s) {
    s = String(s);
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return s.replace(/[!"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~]/g, '\\$&');
  }

  function markPickerEl(el, isPreorder, variant, value) {
    if (!el) return false;
    if (!isPreorder) {
      el.removeAttribute('data-hs-po-variant');
      el.removeAttribute('title');
      el.__hsPoValue = null;
      return false;
    }
    el.setAttribute('data-hs-po-variant', '1');
    el.__hsPoValue = String(value || '');
    var po = _globalPreorderList && _globalPreorderList[String(variant.id)];
    el.__hsPoEta = po && po.eta ? po.eta : null;
    var word = _settings.corner_tag || 'Передзамовлення';
    el.setAttribute('title', po && po.eta ? word + ' — відправка ' + etaPhrase(po.eta) : word);
    return true;
  }

  // Returns the variant matching the current selection but with ONE option swapped.
  function findHypotheticalVariant(currentOpts, optionIndex, newValue, prod) {
    prod = prod || product;
    if (!prod || !prod.variants) return null;
    var target = currentOpts.slice();
    target[optionIndex] = newValue;
    return prod.variants.find(function (v) {
      var vo = v.options || [];
      for (var i = 0; i < target.length; i++) {
        if (target[i] === undefined) continue;
        if (String(vo[i]) !== String(target[i])) return false;
      }
      return true;
    });
  }

  // Fallback when /products/handle.js is unavailable: rebuild a minimal
  // product object from the form's own variant <select> (Dawn/Debutify keep
  // one with option text like "Чорний / 3XL" and value = variant id).
  function productFromForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var f = 0; f < forms.length; f++) {
      var sel = forms[f].querySelector('select[name="id"]');
      if (!sel || !sel.options || sel.options.length < 2) continue;
      var variants = [];
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        if (!o.value) continue;
        var t = (o.getAttribute('data-title') || o.textContent || '').trim().split(' - ')[0];
        if (!t) continue;
        variants.push({ id: o.value, options: t.split(' / ').map(function (s) { return s.trim(); }) });
      }
      if (variants.length) {
        var names = [];
        for (var k = 0; k < variants[0].options.length; k++) names.push('Option ' + (k + 1));
        return { options: names, variants: variants };
      }
    }
    return null;
  }

  var _decorLogged = false;
  function decorateVariantPickers() {
    var prod = product || productFromForm();
    if (!prod || !_globalPreorderList) return;
    if (!prod.options || prod.options.length === 0) return;
    if (!prod.variants || prod.variants.length === 0) return;

    injectPickerStyles();

    var current = prod.variants.find(function (v) { return String(v.id) === String(currentVariantId); });
    if (!current) current = prod.variants[0];
    if (!current) return;
    var currentOpts = current.options || [];

    var totalMarked = 0;
    var totalEvaluated = 0;
    var totalPreorder = 0;
    var missingMatches = [];

    // Clear any leftover badges on options we no longer decorate (e.g. Color
    // from a previous version that badged everything). Without this they'd
    // stay until the user navigates away.
    document.querySelectorAll('[data-hs-po-variant="1"]').forEach(function (el) {
      // Card pills belong to decorateCardPills, which unmarks its own when a
      // pre-order ends. Wiping them here would fight that pass every rerun:
      // remove → mutation → re-add → mutation, forever.
      if (el.matches && el.matches('.size-pill[data-variant-id]')) return;
      el.__hsPoValue = null;
      el.removeAttribute('data-hs-po-variant');
      el.removeAttribute('title');
    });

    // Badge the Size picker (any language). If no option name looks like
    // "size", fall back to decorating every non-color option so stores with
    // custom option names still get badges.
    var sizeRe  = /size|розмір|размер|taille|größe|grösse|talla|misura|maat/i;
    var colorRe = /colou?r|колір|цвет|farbe|couleur|colore/i;
    var hasSizeOption = prod.options.some(function (o) { return sizeRe.test(optionNameOf(o)); });

    prod.options.forEach(function (optionRaw, optionIndex) {
      var optionName = optionNameOf(optionRaw);
      if (hasSizeOption) {
        if (!sizeRe.test(optionName)) return;
      } else {
        if (colorRe.test(optionName)) return;
      }

      var seen = {};
      var uniqueVals = [];
      prod.variants.forEach(function (v) {
        var val = (v.options || [])[optionIndex];
        if (val === undefined || val === null || seen[val]) return;
        seen[val] = true;
        uniqueVals.push(val);
      });
      // The legend is built from the same sizes: which are pre-order (and
      // when), which are in stock, which are sold out.
      _legendModel = buildLegendModel(prod, currentOpts, optionIndex, uniqueVals);

      uniqueVals.forEach(function (value) {
        totalEvaluated++;
        var hypo = findHypotheticalVariant(currentOpts, optionIndex, value, prod);
        if (!hypo) return;
        var po = globalShouldShowPreorder(hypo.id);
        if (po) totalPreorder++;
        var el = findPickerEl(optionName, value, optionIndex, hypo.id);
        if (!el) {
          if (po) missingMatches.push(optionName + '=' + value);
          return;
        }
        if (!_legendModel.anchor) {
          _legendModel.anchor = el.closest('fieldset, .product-form__input, .variant-input-wrapper, .swatch-group, variant-selects, variant-radios') || el.parentElement;
        }
        if (markPickerEl(el, !!po, hypo, value)) totalMarked++;
      });
    });

    updatePreorderLegends();

    // One-line diagnostic so we can verify it's running and why — once.
    if (_decorLogged) return;
    _decorLogged = true;
    try {
      console.log('[HS Preorder] picker decorated: ' + totalMarked + ' of ' +
        totalPreorder + ' pre-order options (out of ' + totalEvaluated +
        ' total)' +
        (missingMatches.length ? ' — UNMATCHED: ' + missingMatches.join(', ') : ''));
    } catch (e) {}
  }

  // Collection/search cards: the theme's size pills are buttons carrying the
  // exact variant id, so pre-order can be marked precisely without any product
  // context (which collection pages don't have). Runs from every global scan;
  // writes only on change so the mutation observer that triggers the scan
  // never sees churn from a no-op pass.
  function decorateCardPills() {
    if (!_globalPreorderList) return;
    var pills = document.querySelectorAll('.size-pill[data-variant-id]');
    if (!pills.length) return;
    var marked = false;
    pills.forEach(function (el) {
      var po = globalShouldShowPreorder(el.getAttribute('data-variant-id'));
      var isMarked = el.getAttribute('data-hs-po-variant') === '1';
      if (po && !isMarked) {
        el.setAttribute('data-hs-po-variant', '1');
        el.__hsPoValue = (el.textContent || '').trim();
        el.__hsPoEta = po.eta || null;
      } else if (!po && isMarked) {
        el.removeAttribute('data-hs-po-variant');
        el.__hsPoValue = null;
        el.__hsPoEta = null;
      }
      if (po) marked = true;
    });
    if (marked) injectPickerStyles();
    updatePreorderLegends();
  }

  // One legend line per size row. Grouped per product form / per card. Hidden
  // pills (e.g. sizes of a colour the card isn't showing) stay marked but
  // don't enter the legend.
  //
  // Product page (form scope): the line appears only after the customer
  // clicks a pre-order size, and then speaks about that size alone — an
  // always-on list made people wonder whether the in-stock sizes were
  // pre-order too. The clock dots stay on the pills either way, so the
  // pre-order sizes are visible before any click.
  //
  // Collection card (no form): the card has no "selected" size, so the line
  // stays always-on but says explicitly that the remaining sizes are in
  // stock.
  // What the size row of the selected colour looks like right now, built from
  // product.js and the API, never from words: pre-order sizes with their own
  // dates, sizes in stock, sizes sold out. The legend renders exactly this, so
  // it can never claim «інші розміри в наявності» when nothing is.
  var _legendModel = null;
  function variantInStock(v) {
    if (!v || !v.available) return false;
    if (v.inventory_quantity === undefined || v.inventory_quantity === null) return true;
    return v.inventory_quantity > 0 || !v.inventory_management;
  }
  function buildLegendModel(prod, currentOpts, optionIndex, uniqueVals) {
    var m = { preorder: [], stock: [], soldout: [], anchor: null };
    uniqueVals.forEach(function (value) {
      var v = findHypotheticalVariant(currentOpts, optionIndex, value, prod);
      if (!v) return;
      var po = globalShouldShowPreorder(v.id);
      if (po) m.preorder.push({ value: String(value), eta: po.eta || null });
      else if (variantInStock(v)) m.stock.push(String(value));
      else m.soldout.push(String(value));
    });
    return m;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  // «XS/S, M/L — близько 25 вересня · XL — близько 30 вересня»: sizes grouped
  // by their own date, because different purchase orders land on different days.
  function preorderPhrase(list) {
    var byEta = {}, order = [];
    list.forEach(function (p) { var k = p.eta || ''; if (!byEta[k]) { byEta[k] = []; order.push(k); } byEta[k].push(p.value); });
    order.sort();
    return order.map(function (k) { return '<b>' + esc(byEta[k].join(', ')) + '</b>' + (k ? ' \u2014 ' + esc(etaPhrase(k)) : ''); }).join(' \u00B7 ');
  }
  function legendRow(kind, html) {
    return '<div class="hs-po-legend__row hs-po-legend__row--' + kind + '"><span class="hs-po-legend__ic hs-po-legend__ic--' + kind + '" aria-hidden="true"></span><span>' + html + '</span></div>';
  }
  function legendHtml(m) {
    var rows = [];
    if (m.preorder.length) rows.push(legendRow('po', esc(_settings.corner_tag || 'Передзамовлення') + ': ' + preorderPhrase(m.preorder)));
    if (m.stock.length) rows.push(legendRow('ok', 'Є зараз: <b>' + esc(m.stock.join(', ')) + '</b> \u2014 відправка як зазвичай'));
    if (m.soldout.length) rows.push(legendRow('no', 'Розпродано: ' + esc(m.soldout.join(', '))));
    return rows.join('');
  }
  function placeLegend(anchor, cls, html, keep) {
    var next = anchor.nextElementSibling;
    var legend = (next && next.classList && next.classList.contains(cls)) ? next : null;
    if (!legend) {
      legend = document.createElement('div');
      legend.className = 'hs-po-legend ' + cls;
      legend.setAttribute('role', 'note');
      anchor.insertAdjacentElement('afterend', legend);
    }
    if (legend.innerHTML !== html) legend.innerHTML = html;
    keep.add(legend);
  }
  function updatePreorderLegends() {
    try {
      var keep = new Set();
      // Product page: one legend under the size row of the main picker, always
      // on while any size of this colour is pre-order.
      if (_legendModel && _legendModel.anchor && _legendModel.preorder.length && _legendModel.anchor.isConnected) {
        injectPickerStyles();
        placeLegend(_legendModel.anchor, 'hs-po-legend--product', legendHtml(_legendModel), keep);
      }
      // Collection cards: one box per card, built from that card's own pills
      // in a single pass. Cards WITHOUT a pre-order get one too — keying the
      // scan on pre-order pills meant a fully-stocked card rendered nothing
      // and left a blank hole in the grid next to cards that had a box.
      var cards = new Map();
      document.querySelectorAll('.size-pill').forEach(function (el) {
        if (el.offsetParent === null) return;
        var row = el.closest('.custom-size-pills') || el.parentElement;
        // The product page draws its own legend from the real variant data.
        if (!row || row.closest('form[action*="/cart/add"]')) return;
        var val = (el.textContent || '').trim();
        if (!val) return;
        var g = cards.get(row);
        if (!g) { g = { preorder: [], stock: [], soldout: [] }; cards.set(row, g); }
        if (el.getAttribute('data-hs-po-variant') === '1') {
          g.preorder.push({ value: el.__hsPoValue || val, eta: el.__hsPoEta || null });
        } else if (el.getAttribute('data-available') === 'false' || el.disabled) {
          g.soldout.push(val);
        } else {
          g.stock.push(val);
        }
      });
      cards.forEach(function (g, row) {
        if (!g.preorder.length && !g.stock.length && !g.soldout.length) return;
        injectPickerStyles();
        placeLegend(row, 'hs-po-legend--card', legendHtml(g), keep);
      });
      document.querySelectorAll('.hs-po-legend').forEach(function (l) { if (!keep.has(l)) l.remove(); });
    } catch (e) {}
  }

  // Re-decorate when the theme re-renders the picker (e.g. on variant change).
  // Throttled — themes can fire many mutations during a single switch.
  var _pickerObs = null;
  var _pickerObsLast = 0;
  function watchPickerForReRender() {
    if (_pickerObs) return;
    _pickerObs = new MutationObserver(function (records) {
      // The gallery slider and our own legend live in the same section and
      // toggle classes all the time; only picker-side changes matter.
      var relevant = records.some(function (r) {
        var t = r.target.nodeType === 1 ? r.target : r.target.parentElement;
        if (!t || !t.closest) return true;
        return !t.closest('.product__media-wrapper, slider-component, .thumbnail-list') && !inOurNode(t);
      });
      if (!relevant) return;
      var now = Date.now();
      if (now - _pickerObsLast < 200) return;
      _pickerObsLast = now;
      // requestAnimationFrame ensures the theme's DOM updates have settled
      requestAnimationFrame(decorateVariantPickers);
    });
    // product-info survives the theme's variant re-render; body is the fallback.
    var root = document.querySelector('product-info') || document.body;
    _pickerObs.observe(root, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-option-value', 'aria-checked', 'aria-pressed', 'class'] });
  }

  // ── Date formatter ────────────────────────────────────────────────────────
  // Respects _settings.date_format. 'long' = "June 15, 2026", 'short' = "15 Jun
  // 2026", 'iso' = "2026-06-15". Falls through to 'long' if value unrecognized.
  var UK_MONTHS = ['січня', 'лютого', 'березня', 'квітня', 'травня', 'червня', 'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'];
  function formatDate(dateStr) {
    if (!dateStr) return '';
    var p = String(dateStr).split('-');
    if (p.length < 3) return dateStr;
    var year  = p[0];
    var month = parseInt(p[1], 10);
    var day   = parseInt(p[2], 10);
    if (isNaN(month) || isNaN(day)) return dateStr;
    var fmt = _settings.date_format || 'uk';
    if (fmt === 'iso') return year + '-' + String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0');
    var lang = _settings.language || document.documentElement.lang || 'uk';
    // Ukrainian reads «25 вересня»; the year only when it is not this year.
    if (fmt === 'uk' || String(lang).slice(0, 2) === 'uk') {
      var y = parseInt(year, 10);
      return day + ' ' + (UK_MONTHS[month - 1] || month) + (y !== new Date().getFullYear() ? ' ' + y : '');
    }
    try {
      var d = new Date(parseInt(year, 10), month - 1, day);
      return d.toLocaleDateString(lang, fmt === 'short'
        ? { day: 'numeric', month: 'short', year: 'numeric' }
        : { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) {
      return day + '.' + String(month).padStart(2, '0') + '.' + year;
    }
  }
  function etaPhrase(eta) { return eta ? 'близько ' + formatDate(eta) : ''; }

  // ── Apply settings template to a string: replaces {{eta}} with formatted date.
  function applyTemplate(tpl, eta) {
    if (!tpl) return '';
    return String(tpl).replace(/\{\{\s*eta\s*\}\}/g, formatDate(eta));
  }

  // ── Find the MAIN product form ─────────────────────────────────────────────
  // The page has multiple cart forms — quick-add widgets, hidden duplicates,
  // bundle forms, etc. The REAL one has:
  //   1. A variant ID matching our preorderData keys, AND
  //   2. An actual visible add-to-cart button
  // The set of variant ids that identify THIS product's main form. Once
  // product.js has loaded we use ALL of the product's variant ids — not just
  // the pre-order ones — so switching to a plain sold-out variant still
  // resolves the form (otherwise the script goes blind and can't clean up the
  // previous variant's pre-order notice/button). Falls back to the Liquid
  // pre-order keys before product.js arrives.
  function mainFormVariantIds() {
    if (product && product.variants && product.variants.length) {
      return product.variants.map(function (v) { return String(v.id); });
    }
    return preorderKeys;
  }

  function findMainProductForm() {
    var ids = mainFormVariantIds();
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var idEl = forms[i].querySelector('input[name="id"], select[name="id"]');
      if (!idEl || ids.indexOf(String(idEl.value)) === -1) continue;

      // Must have a submit button (skips hidden/duplicate forms)
      var btn = forms[i].querySelector('[name="add"]') ||
                forms[i].querySelector('#AddToCart')    ||
                forms[i].querySelector('[data-add-to-cart]') ||
                forms[i].querySelector('button[type="submit"]');
      if (!btn) continue;

      // Skip if the button is for "Add selected items" (bundle button)
      var txt = (btn.textContent || '').toLowerCase();
      if (txt.indexOf('selected') !== -1) continue;

      return forms[i];
    }
    return null;
  }

  // ── Button finder (now scoped to main product form) ───────────────────────
  function findBtn() {
    var form = findMainProductForm();
    if (form) {
      return form.querySelector('[name="add"]') ||
             form.querySelector('#AddToCart')    ||
             form.querySelector('[data-add-to-cart]') ||
             form.querySelector('button[type="submit"]');
    }
    return null;
  }

  // ── Get variant ID from main product form ─────────────────────────────────
  function getFormVariantId() {
    var form = findMainProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="id"], select[name="id"]');
    return input ? input.value : null;
  }

  // ── Stock check ────────────────────────────────────────────────────────────
  // This system is exclusive to the Beirut location. We treat a variant as
  // "pre-order" only if:
  //   - it has an active PO, AND
  //   - Beirut inventory is <= 0 (or unknown)
  // We prefer the API value (_globalPreorderList[id].inventory) because it
  // is Beirut-only. The Liquid-injected `data.inventory` is the TOTAL across
  // all locations, so we only fall back to it when the API hasn't loaded yet.
  function isVariantOutOfStock(variantId) {
    var id = String(variantId);

    // Prefer Beirut-only inventory from the API (most accurate)
    if (_globalPreorderList && _globalPreorderList[id]) {
      var po = _globalPreorderList[id];
      if (po.inventory !== null && po.inventory !== undefined) {
        return po.inventory <= 0;
      }
      // PO is active but Beirut inventory unknown → default to out of stock
      return true;
    }

    // Fallback to Liquid data (total across all locations) while API is loading
    var data = preorderData[id];
    if (!data) return false;
    if (!data.inventory_managed) return false;
    var qty = Number(data.inventory);
    if (isNaN(qty)) return false;
    return qty <= 0;
  }

  // ── Core: stamp pre-order state onto the button ───────────────────────────
  function applyPreorderState(variantId) {
    if (_applying) return;
    _applying = true;

    var id   = String(variantId);
    var data = preorderData[id];

    // Decide "has active PO" from the API (_globalPreorderList) when it's
    // loaded — the API is authoritative because it queries our purchase_orders
    // table directly. Stale Liquid metafields (from cancelled POs that didn't
    // get cleared) used to falsely flip the button to pre-order; now we
    // ignore them once the API has spoken.
    var apiHasIt = _globalPreorderList && Object.prototype.hasOwnProperty.call(_globalPreorderList, id);
    var hasActivePo;
    if (_globalPreorderList) {
      hasActivePo = apiHasIt;
      // Sync the eta if API returned it (in case Liquid had a stale one)
      if (apiHasIt && _globalPreorderList[id] && _globalPreorderList[id].eta) {
        data = data || {};
        data.eta = _globalPreorderList[id].eta;
      }
    } else {
      // API hasn't loaded yet — fall back to Liquid metafields temporarily
      hasActivePo = !!(data && (data.active === true || data.active === 'true'));
    }

    var outOfStock  = isVariantOutOfStock(id);

    // Pre-order behavior ONLY when PO is active AND the variant is out of stock.
    var isPreorder = hasActivePo && outOfStock;

    var btn = findBtn();
    if (!btn) { _applying = false; return; }

    // Remove previous notice & hidden inputs
    var oldNotice = document.getElementById('hs-preorder-notice');
    if (oldNotice) oldNotice.remove();

    var form = btn.closest('form');
    if (form) {
      // Remove any previously-injected pre-order line item properties
      form.querySelectorAll('input[data-hs-preorder-property]').forEach(function (el) {
        el.remove();
      });
    }

    if (isPreorder) {
      injectStyles();
      setPreorderConflictsHidden(true, btn);

      btn.removeAttribute('disabled');
      btn.setAttribute('data-hs-preorder', 'true');
      btn.style.opacity        = '1';
      btn.style.pointerEvents  = 'auto';
      btn.style.cursor         = 'pointer';

      var label = applyTemplate(_settings.button_text, data.eta);

      // Force a filled, readable pre-order button regardless of the theme's
      // buy-button style (some are white/outline, which made the overlay text
      // white-on-white). Accent background + white label.
      btn.style.setProperty('background-color', accentColor(), 'important');
      btn.style.setProperty('background-image', 'none', 'important');
      btn.style.setProperty('border-color', accentColor(), 'important');
      setOverlayText(btn, label, inkFor(accentColor()));
      // Remove any v25-era .hs-po-label DOM element on first run (theme upgrade)
      var staleLabel = btn.querySelector('.hs-po-label');
      if (staleLabel) staleLabel.remove();

      // Customer-facing notice (under the button on product page) — comes
      // from per-shop _settings.notice_text. Gated by show_notice toggle.
      if (_settings.show_notice !== 0 && _settings.show_notice !== false) {
        injectPickerStyles();
        var notice = document.createElement('div');
        notice.id = 'hs-preorder-notice';
        notice.setAttribute('role', 'note');
        notice.innerHTML = '<span class="hs-po-legend__ic hs-po-legend__ic--po" aria-hidden="true"></span><span></span>';
        notice.lastChild.textContent = applyTemplate(_settings.notice_text, data.eta);
        if (form) { form.appendChild(notice); }
        else       { btn.insertAdjacentElement('afterend', notice); }
      }

      if (form) {
        // 1) HIDDEN property — for our backend webhook + Shopify Function (COD hider)
        ensureProperty(form, '_preorder_eta', data.eta);
        // 2) FLAG property — easy to match in Shopify Payment Customization rules.
        ensureProperty(form, '_hs_preorder', 'true');
        // 3) VISIBLE property — shown to customer in cart, checkout & order email.
        //    Property name (no leading underscore) is what makes it visible.
        ensureProperty(form, _settings.property_label, applyTemplate(_settings.property_text || _settings.notice_text, data.eta));

        // Cap the qty input if merchant set a max
        applyQtyCap(form);
      }
    } else {
      // ── CLEANUP ───────────────────────────────────────────────────────
      setPreorderConflictsHidden(false);
      btn.removeAttribute('data-hs-preorder');
      btn.removeAttribute('data-hs-po-text');
      btn.style.removeProperty('--hs-po-color');
      btn.style.removeProperty('background-color');
      btn.style.removeProperty('background-image');
      btn.style.removeProperty('border-color');
      if (btn.getAttribute('data-hs-po-aria') === '1') { btn.removeAttribute('aria-label'); btn.removeAttribute('data-hs-po-aria'); }
      var poLabel = btn.querySelector('.hs-po-label');
      if (poLabel) poLabel.remove();
    }

    dlvProductState(form, btn, isPreorder, data && data.eta, id);
    _applying = false;
  }

  // ── Burst reapply after variant switch ────────────────────────────────────
  function burstReapply(variantId) {
    currentVariantId = String(variantId);
    if (_burstTimer) clearInterval(_burstTimer);

    applyPreorderState(currentVariantId);
    decorateVariantPickers(); // re-evaluate picker badges for the new context

    var ticks = 0;
    _burstTimer = setInterval(function () {
      applyPreorderState(currentVariantId);
      ticks++;
      if (ticks >= 20) {
        clearInterval(_burstTimer);
        _burstTimer = null;
      }
    }, 150);
  }

  // ── PRIMARY DETECTION: poll the main form's hidden input ──────────────────
  setInterval(function () {
    if (_applying) return;
    var formVid = getFormVariantId();
    if (!formVid) return;
    formVid = String(formVid);

    if (formVid !== currentVariantId) {
      burstReapply(formVid);
    }
  }, 250);

  // ── GUARDIAN: ensure correct state ────────────────────────────────────────
  setInterval(function () {
    if (_applying || _burstTimer) return;
    var cid = currentVariantId;
    if (!cid) return;

    // API is authoritative once loaded; Liquid metafields are the fallback.
    var isPreorder;
    if (_globalPreorderList) {
      isPreorder = !!globalShouldShowPreorder(cid);
    } else {
      var d = preorderData[cid];
      isPreorder = !!(d && (d.active === true || d.active === 'true'));
    }
    var btn = findBtn();
    if (!btn) return;

    // v26: presence of data-hs-po-text marks it as overlay-applied. Also
    // re-apply when the theme re-rendered the form and deleted our notice.
    var noticeMissing = (_settings.show_notice !== 0 && _settings.show_notice !== false)
      && !document.getElementById('hs-preorder-notice');
    if (isPreorder && (!btn.hasAttribute('data-hs-po-text') || noticeMissing)) {
      applyPreorderState(cid);
    } else if (!isPreorder && (btn.hasAttribute('data-hs-po-text') || btn.getAttribute('data-hs-preorder') === 'true')) {
      applyPreorderState(cid);
    }
  }, 500);

  // ── Variant-change events ─────────────────────────────────────────────────
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && String(v.id) !== currentVariantId) burstReapply(v.id);
  });

  document.addEventListener('variantChange', function (e) {
    var v = e.detail && (e.detail.variant || e.detail);
    if (v && v.id && String(v.id) !== currentVariantId) burstReapply(v.id);
  });

  // ── Variant lookup helper ─────────────────────────────────────────────────
  function findVariant(id) {
    if (!product) return null;
    return product.variants.find(function (v) { return String(v.id) === String(id); });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  function init() {
    var isProductPage = window.location.pathname.indexOf('/products/') !== -1;

    if (isProductPage) {
      // Product page: load product.js regardless of whether the Liquid snippet
      // injected pre-order data — picker badges only need product + API list.
      var parts = window.location.pathname.split('/products/');
      var handle = parts[1].split('?')[0].split('/')[0];
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          product = p;
          var formVid = getFormVariantId();
          var urlId = new URLSearchParams(window.location.search).get('variant');
          var initialId = formVid || urlId;
          var variant = initialId ? findVariant(initialId) : null;
          if (!variant) variant = p.variants[0];
          if (variant) burstReapply(variant.id);
          // Mark pre-order options in the picker so the customer doesn't have
          // to click each one to find out which are pre-order.
          decorateVariantPickers();
          watchPickerForReRender();
        })
        .catch(function (e) { console.warn('[HS Preorder]', e); });
    }

    // On EVERY page (including collection, search, recommendations widgets):
    // fetch the global pre-order variant list and intercept add-to-cart actions.
    initGlobalIntercept();
    initVipEarlyAccess();
  }

  // ══════════════════════════════════════════════════════════════════════════
  // GLOBAL ADD-TO-CART INTERCEPT (works on all pages, all add-to-cart paths)
  // ══════════════════════════════════════════════════════════════════════════

  var _globalPreorderList = null;  // { variantId: { eta } } - fetched from our API

  function initGlobalIntercept() {
    var apiUrl = window.__HS_PREORDER_API;
    if (!apiUrl) return;

    // The API answers with max-age=60 (stale-while-revalidate on the server);
    // letting the browser cache honour it saves a cross-origin round trip on
    // every page view within a minute.
    fetch(apiUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        _globalPreorderList = data.variants || {};
        if (Object.keys(_globalPreorderList).length === 0) return;

        // 1) Scan & relabel all add-to-cart buttons currently on the page
        scanAndApplyPreorderUI();
        // Variant picker badges depend on API data — decorate now in case
        // product.js finished loading before the API call did.
        decorateVariantPickers();

        // 2) Re-scan when the DOM changes (lazy-loaded recommendations, etc.)
        // Only mutations that can carry a buy form, a size pill or a sold-out /
        // notify widget count. Sliders, review carousels, the ticker and our
        // own legend/label nodes mutate constantly; rescanning on those kept
        // the main thread busy and made taps slow (INP 256–286 ms, 2026-09-17).
        var scanTimer = null;
        var runScan = function () {
          scanTimer = null;
          scanAndApplyPreorderUI();
          // Re-hide the theme's notify/sold-out UI in case it was (re)injected
          // after our last pass — Debutify renders it asynchronously.
          reapplyConflictHideIfActive();
          // The cart re-renders its lines from the server on every change, so
          // the option labels have to be put back each time.
          try { if (document.querySelector('select[data-option-name]')) markCartLines(); } catch (e) { /* the cart still works */ }
        };
        new MutationObserver(function (records) {
          if (scanTimer || !mutationsMatter(records)) return;
          scanTimer = setTimeout(runScan, 300);
        }).observe(document.body, { childList: true, subtree: true });

        // 2b) Collection cards change colour by hiding and showing their size
        // pills (inline style) and moving .active — no node is added, so the
        // observer above never fires and the legend kept the first colour's
        // sizes. Rebuild once the theme's own onclick has run.
        document.addEventListener('click', function (e) {
          var t = e.target && e.target.closest && e.target.closest('.swatch-circle, .custom-card-swatches, .size-pill');
          if (!t) return;
          requestAnimationFrame(scanAndApplyPreorderUI);
          setTimeout(scanAndApplyPreorderUI, 250);
        });

        // 3) Intercept ALL form submissions to /cart/add (catches any path)
        document.addEventListener('submit', interceptFormSubmit, true);

        // 4) Intercept fetch() calls to /cart/add (AJAX quick-adds)
        wrapFetchForCartAdd();
      })
      .catch(function (e) { console.warn('[HS Preorder] API fetch failed:', e); });
  }

  // Does a batch of DOM mutations need a pre-order rescan? Yes when something
  // that is not ours arrived and it is (or holds) a buy form, a size pill, a
  // button or a sold-out/notify widget — or when anything changed inside the
  // product block whose sold-out/notify UI we are currently hiding.
  var RESCAN_SEL = 'form[action*="/cart/add"], .size-pill, button, .shopify-payment-button, ' +
    '[class*="notify"], [class*="back-in-stock"], [class*="sold"], [class*="unavailable"], [class*="out-of-stock"]';
  var OUR_NODES_SEL = '[class^="hs-"], [class*=" hs-"], [id^="hs-"]';
  // Inside one of our own nodes? <html> and <body> never count: hs-np.js puts
  // `hs-np-on` on <html>, and closest() alone then called EVERY node ours, so
  // no mutation ever triggered a rescan.
  function inOurNode(el) {
    for (; el && el.nodeType === 1 && el !== document.body && el !== document.documentElement; el = el.parentElement) {
      if (el.matches && el.matches(OUR_NODES_SEL)) return true;
    }
    return false;
  }
  function isOurNode(n) {
    return inOurNode(n.nodeType === 1 ? n : n.parentElement);
  }
  function mutationsMatter(records) {
    var scope = (_conflictBtn && _conflictBtn.isConnected) ? productScopeFor(_conflictBtn) : null;
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1 && n.nodeType !== 3) continue;
        if (isOurNode(n)) continue;
        if (scope && scope !== document.body && scope.contains(n)) return true;
        if (n.nodeType === 1 && ((n.matches && n.matches(RESCAN_SEL)) || (n.querySelector && n.querySelector(RESCAN_SEL)))) return true;
      }
    }
    return false;
  }

  // Re-label every add-to-cart button on the page whose form's variant is a pre-order
  function scanAndApplyPreorderUI() {
    if (!_globalPreorderList) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      labelFormIfPreorder(forms[i]);
    }
    decorateCardPills();
  }

  // Should this variant currently be treated as pre-order?
  // PO active AND out of stock at Beirut (inventory <= 0 or unknown)
  function globalShouldShowPreorder(variantId) {
    if (!_globalPreorderList) return null;
    var po = _globalPreorderList[String(variantId)];
    if (!po) return null;
    if (po.inventory !== null && po.inventory !== undefined && po.inventory > 0) return null;
    return po;
  }

  function labelFormIfPreorder(form) {
    var idEl = form.querySelector('input[name="id"], select[name="id"]');
    if (!idEl) return;
    var vid = String(idEl.value);
    var po = globalShouldShowPreorder(vid);
    if (!po) {
      // Not pre-order (no PO OR in stock) — remove our markers if any
      var btn = form.querySelector('[name="add"], button[type="submit"]');
      if (btn && btn.getAttribute('data-hs-preorder-global') === '1') {
        btn.removeAttribute('data-hs-preorder-global');
        btn.removeAttribute('data-hs-preorder');
        btn.removeAttribute('data-hs-po-text');
        btn.style.removeProperty('--hs-po-color');
        btn.style.removeProperty('background-color');
        btn.style.removeProperty('background-image');
      btn.style.removeProperty('border-color');
      if (btn.getAttribute('data-hs-po-aria') === '1') { btn.removeAttribute('aria-label'); btn.removeAttribute('data-hs-po-aria'); }
        var lbl = btn.querySelector('.hs-po-label');
        if (lbl) lbl.remove();
      }
      // Also remove injected hidden inputs
      form.querySelectorAll('input[data-hs-preorder-property]').forEach(function (el) { el.remove(); });
      return;
    }

    // PRE-ORDER variant — re-label button + inject properties
    injectStyles();
    var btn = form.querySelector('[name="add"], button[type="submit"]');
    if (!btn) return;
    if (btn.getAttribute('data-hs-preorder-global') === '1') return;  // already done

    btn.setAttribute('data-hs-preorder-global', '1');
    btn.setAttribute('data-hs-preorder', 'true');
    btn.style.setProperty('background-color', accentColor(), 'important');
    btn.style.setProperty('background-image', 'none', 'important');
    btn.style.setProperty('border-color', accentColor(), 'important');
    setOverlayText(btn, applyTemplate(_settings.button_text, po.eta), inkFor(accentColor()));
    var staleLbl = btn.querySelector('.hs-po-label');
    if (staleLbl) staleLbl.remove();

    // Inject hidden properties so the cart line item is marked as pre-order
    ensureProperty(form, '_preorder_eta', po.eta);
    ensureProperty(form, '_hs_preorder', 'true');
    ensureProperty(form, _settings.property_label, applyTemplate(_settings.property_text || _settings.notice_text, po.eta));

    applyQtyCap(form);
  }

  // ── Quantity cap ─────────────────────────────────────────────────────────
  // Honors _settings.max_qty_per_order (0 = unlimited). Sets `max` + `value`
  // on the form's quantity input so the customer can't request more than the
  // merchant allows on a single pre-order line.
  function applyQtyCap(form) {
    var cap = parseInt(_settings.max_qty_per_order, 10);
    if (!cap || cap < 1) return;
    var qty = form.querySelector('input[name="quantity"]');
    if (!qty) return;
    if (qty.getAttribute('data-hs-cap') === String(cap)) return;
    qty.setAttribute('max', String(cap));
    qty.setAttribute('data-hs-cap', String(cap));
    var n = parseInt(qty.value, 10);
    if (isNaN(n) || n > cap) qty.value = String(Math.min(cap, isNaN(n) ? 1 : n));
  }

  function ensureProperty(form, key, value) {
    var existing = form.querySelector('input[name="properties[' + key + ']"]');
    if (existing) { existing.value = value; return; }
    var inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = 'properties[' + key + ']';
    inp.value = value;
    inp.setAttribute('data-hs-preorder-property', '1');
    form.appendChild(inp);
  }

  // Intercept synchronous form POSTs to /cart/add (legacy themes)
  function interceptFormSubmit(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    labelFormIfPreorder(form);  // ensure properties are in form data before submit
  }

  // Wrap window.fetch so AJAX add-to-cart requests get pre-order properties added
  // Every way the cart can change: the theme's add, the quantity stepper, the
  // remove link, a cleared cart. Reading /cart.js when one of these resolves is
  // exact — no guessing, and never a read after a tap that changed nothing.
  var CART_WRITE_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var _cartReadQueued = false;
  function cartChanged() {
    if (_cartReadQueued) return;
    _cartReadQueued = true;
    setTimeout(function () { _cartReadQueued = false; refreshCartState(); }, 120);
  }

  // Five scripts (ours, the theme, Shopify's own) each read /cart.js on load —
  // 9–21 reads per page (critique 2026-10-06). Reads that start within
  // CART_READ_SHARE_MS of each other, with no cart write between, share one
  // request; each caller gets its own copy of the answer.
  var CART_READ_RE = /\/cart\.js(\?|$)/;
  var CART_READ_SHARE_MS = 400;
  var _sharedCartRead = null;
  function isCartRead(url, init) {
    var method = String((init && init.method) || 'GET').toUpperCase();
    return method === 'GET' && CART_READ_RE.test(url);
  }

  function wrapFetchForCartAdd() {
    if (!window.fetch || window.fetch.__hs_wrapped) return;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') !== -1 && init && init.body) {
          init.body = augmentCartAddBody(init.body);
        }
        if (typeof input === 'string' && isCartRead(url, init)) {
          var now = Date.now();
          if (!_sharedCartRead || now - _sharedCartRead.at > CART_READ_SHARE_MS) {
            var shared = { at: now, p: origFetch.apply(this, arguments) };
            _sharedCartRead = shared;
            shared.p.catch(function () { if (_sharedCartRead === shared) _sharedCartRead = null; });
          }
          return _sharedCartRead.p.then(function (r) { return r.clone(); });
        }
        if (CART_WRITE_RE.test(url)) _sharedCartRead = null;
      } catch (e) { /* fall through */ }
      var out = origFetch.apply(this, arguments);
      try {
        // A read shared while the write was in flight may hold the old cart.
        var settle = function () { _sharedCartRead = null; };
        if (CART_WRITE_RE.test(url) && out && out.then) out.then(function () { settle(); cartChanged(); }, settle);
      } catch (e) { /* the page's own fetch result is never ours to break */ }
      return out;
    };
    window.fetch.__hs_wrapped = true;
    // Older themes (and Debutify's quantity stepper) still use XMLHttpRequest.
    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__hs_wrapped) {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        try {
          if (CART_WRITE_RE.test(String(url || ''))) {
            _sharedCartRead = null;
            this.addEventListener('loadend', function () { _sharedCartRead = null; cartChanged(); });
          }
        } catch (e) { /* noop */ }
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.__hs_wrapped = true;
    }
  }

  // Add pre-order properties to a /cart/add request body
  function augmentCartAddBody(body) {
    if (!_globalPreorderList) return body;

    // JSON body
    if (typeof body === 'string' && body.trim().startsWith('{')) {
      try {
        var parsed = JSON.parse(body);
        var items = parsed.items || (parsed.id ? [parsed] : null);
        if (!items) return body;
        items.forEach(function (item) {
          var vid = String(item.id || '');
          var po = globalShouldShowPreorder(vid);
          if (!po) return;
          item.properties = item.properties || {};
          if (!item.properties['_preorder_eta']) {
            item.properties['_preorder_eta'] = po.eta;
            item.properties['_hs_preorder'] = 'true';
            item.properties[_settings.property_label] = applyTemplate(_settings.property_text || _settings.notice_text, po.eta);
          }
          // Cap quantity if merchant configured a max
          var cap = parseInt(_settings.max_qty_per_order, 10);
          if (cap && cap > 0) {
            var q = parseInt(item.quantity, 10);
            if (!q || q > cap) item.quantity = cap;
          }
        });
        return JSON.stringify(parsed);
      } catch (e) { return body; }
    }

    // FormData / URLSearchParams body
    if (body instanceof FormData || body instanceof URLSearchParams) {
      var vid = String(body.get('id') || '');
      var po = globalShouldShowPreorder(vid);
      if (!po) return body;
      if (!body.has('properties[_preorder_eta]')) {
        body.append('properties[_preorder_eta]', po.eta);
        body.append('properties[_hs_preorder]', 'true');
        body.append('properties[' + _settings.property_label + ']', applyTemplate(_settings.property_text || _settings.notice_text, po.eta));
      }
      var cap2 = parseInt(_settings.max_qty_per_order, 10);
      if (cap2 && cap2 > 0) {
        var q = parseInt(body.get('quantity'), 10);
        if (!q || q > cap2) body.set('quantity', String(cap2));
      }
    }

    return body;
  }

  // ══════════════════════════════════════════════════════════════════════════
  // CART UI — COD warning banner + per-line "ships around <eta>" labels
  // ══════════════════════════════════════════════════════════════════════════
  // Polls /cart.js (lightweight, themes already call it themselves) and renders
  // a banner near checkout buttons whenever the cart contains a pre-order line.
  // Watches the DOM so it survives cart-drawer open / re-render cycles.
  var _cartUIBound = false;
  var _lastCartHasPreorder = null;
  var _cartLastEta = null;

  function cartVisible() {
    if (/^\/cart(\/|$)/.test(window.location.pathname)) return true;
    var d = document.querySelector('cart-drawer.active, cart-drawer.is-open, #CartDrawer.active, .drawer.is-open, .cart-drawer.is-open, cart-notification.active, .mini-cart.is-open');
    return !!(d && (d.offsetParent || d.getClientRects().length));
  }
  function setupCartUI() {
    if (_cartUIBound) {
      // Settings might have changed — refresh now and on the next cart poll
      renderCartUI(_lastCartHasPreorder, _cartEtas);
      return;
    }
    _cartUIBound = true;
    refreshCartState();
    // Re-check after interaction (add to cart, drawer open); the theme's own
    // cart request is usually done within a second.
    // Only taps that can change or reveal the cart: every other tap used to
    // fire two /cart.js requests.
    // A cart write tells us the cart changed (wrapFetchForCartAdd below reads
    // it once the write resolves), so clicks only have to cover what opens the
    // cart without changing it — a drawer trigger, the cart link. The old
    // selector matched any [class*="cart"] and every submit button, and each
    // match cost two /cart.js reads on a 4G phone.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('[href*="/cart"], [class*="cart-drawer"], [class*="cart-toggle"], [class*="cart-icon"], [data-cart-drawer], [aria-controls*="cart"], .custom-qv-trigger')) return;
      setTimeout(refreshCartState, 400);
    }, true);
    // A light safety net, only while a cart is actually on screen.
    setInterval(function () { if (cartVisible()) refreshCartState(); }, 4000);
  }

  var _cartEtas = [];
  function refreshCartState() {
    try {
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasPreorder = false;
          var hasStock = false;
          var etas = [];
          (cart.items || []).forEach(function (item) {
            var p = item.properties || {};
            if (p._hs_preorder || p._preorder_eta) {
              hasPreorder = true;
              if (p._preorder_eta && etas.indexOf(p._preorder_eta) === -1) etas.push(p._preorder_eta);
            } else if (item.requires_shipping !== false) {
              hasStock = true;
            }
          });
          etas.sort();
          _lastCartHasPreorder = hasPreorder;
          _cartEtas = etas;
          _cartLastEta = etas[0] || null;
          _cartHasStock = hasStock;
          // While a tick is being saved the cart may still answer with the old value.
          if (!_splitPending) _cartSplit = !!(cart.attributes && cart.attributes[SPLIT_ATTR] === SPLIT_YES);
          renderCartUI(hasPreorder, etas);
          syncSets(cart);
          markCartLines();
          // The cart is no longer mixed: a tick left in it would mean nothing.
          if (_cartSplit && !_splitPending && !(hasPreorder && hasStock)) saveSplit(false);
        })
        .catch(function () { /* silent */ });
    } catch (e) { /* silent */ }
  }

  // ── Cart lines: what each size in the dropdown actually is ───────────────
  // The theme's per-line dropdowns list every option value, in stock or not,
  // and accept a change in silence: a sold-out size is taken, and she finds
  // out at the checkout — or the order is placed and cancelled later, which is
  // the one thing this shop cannot afford (critique 2026-09-21). Each option
  // now says what it is: «розпродано», which cannot be chosen, or
  // «передзамовлення до DD.MM», which can. Nothing here blocks the cart.
  var _catalog = {};        // handle → product json (or a promise while it loads)

  function productByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    var hit = _catalog[handle];
    if (hit) return hit.then ? hit : Promise.resolve(hit);
    var p = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) { _catalog[handle] = json; return json; })
      .catch(function () { _catalog[handle] = null; return null; });
    _catalog[handle] = p;
    return p;
  }

  // The variant this line would become if one option changed to `value` —
  // with no override, the one it is now.
  function variantFor(product, chosen, optionName, value) {
    var names = (product.options || []).map(function (o) { return o && o.name ? o.name : o; });
    var want = names.map(function (n) { return n === optionName ? value : chosen[n]; });
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var same = true;
      for (var j = 0; j < want.length; j++) if (want[j] != null && v.options[j] !== want[j]) { same = false; break; }
      if (same) return v;
    }
    return null;
  }

  function preorderEta(variantId) {
    var id = String(variantId);
    if (_globalPreorderList && Object.prototype.hasOwnProperty.call(_globalPreorderList, id)) {
      return (_globalPreorderList[id] && _globalPreorderList[id].eta) || null;
    }
    var local = preorderData[id];
    return local && local.eta ? local.eta : null;
  }

  // «XS/S», «XS/S — розпродано», «XS/S — передзамовлення до 5 жовтня».
  function optionLabel(base, variant) {
    if (!variant) return { text: base + ' — немає', off: true };
    if (variant.available) return { text: base, off: false };
    var eta = preorderEta(variant.id);
    if (eta) return { text: base + ' — передзамовлення до ' + formatDate(eta), off: false };
    return { text: base + ' — розпродано', off: true };
  }

  function lineRows() {
    var out = [];
    var sels = document.querySelectorAll('select[data-option-name]');
    for (var i = 0; i < sels.length; i++) {
      var row = sels[i].closest('tr, li, .cart-item');
      if (row && out.indexOf(row) === -1) out.push(row);
    }
    return out;
  }

  function markRow(row) {
    var link = row.querySelector('a[href*="/products/"]');
    if (!link) return;
    // The theme prints the handle already percent-encoded; decode it so
    // productByHandle's own encoding does not turn Cyrillic into %25D0… (404).
    var handle = String(link.getAttribute('href') || '').split('/products/')[1];
    handle = handle ? handle.split('?')[0].split('#')[0] : '';
    try { handle = decodeURIComponent(handle); } catch (e) { /* keep as is */ }
    var sels = [].slice.call(row.querySelectorAll('select[data-option-name]'));
    if (!handle || !sels.length) return;
    productByHandle(handle).then(function (product) {
      if (!product || !product.variants || !document.documentElement.contains(row)) return;
      var chosen = {};
      sels.forEach(function (sel) { chosen[sel.dataset.optionName] = sel.value; });
      sels.forEach(function (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          var opt = sel.options[i];
          var base = opt.getAttribute('data-hs-base') || opt.textContent.trim();
          opt.setAttribute('data-hs-base', base);
          var state = optionLabel(base, variantFor(product, chosen, sel.dataset.optionName, opt.value));
          if (opt.textContent !== state.text) opt.textContent = state.text;
          // The size she already has stays selectable — taking it away would
          // strand the line; the note under it says what is wrong instead.
          opt.disabled = state.off && opt.value !== sel.value;
        }
      });
      var now = variantFor(product, chosen);   // no override: the variant she has now
      var gone = now && !now.available && !preorderEta(now.id);
      var note = row.querySelector('.hs-line-gone');
      if (gone && !note) {
        note = document.createElement('p');
        note.className = 'hs-line-gone';
        note.textContent = 'Цей розмір розпродано — обери інший або прибери з кошика.';
        (sels[sels.length - 1].closest('.select') || sels[sels.length - 1]).insertAdjacentElement('afterend', note);
      } else if (!gone && note) {
        note.remove();
      }
    });
  }

  function markCartLines() {
    injectCartLineStyles();
    lineRows().forEach(markRow);
  }

  var _lineStyled = false;
  function injectCartLineStyles() {
    if (_lineStyled) return;
    _lineStyled = true;
    var st = document.createElement('style');
    st.id = 'hs-cart-lines-css';
    // Everything she taps in a cart line was under the 44px a thumb needs:
    // the size and colour dropdowns were 159×27 at 12.6px, which on iOS also
    // zooms the page when tapped (critique 2026-09-21).
    // The theme sizes these from a more specific rule of its own, so these
    // two properties are forced; everything else is left to the theme.
    st.textContent = '.cart-item select.select__select,.cart-item .select{min-height:44px!important}'
      + '.cart-item select.select__select{font-size:16px!important;padding-top:0;padding-bottom:0}'
      + 'cart-items .quantity__button,cart-drawer-items .quantity__button{min-width:44px;min-height:44px}'
      + 'cart-items .quantity__input,cart-drawer-items .quantity__input{min-height:44px;font-size:16px}'
      + 'cart-items .cart-remove-button,cart-drawer-items .cart-remove-button{min-width:44px;min-height:44px;display:inline-flex;align-items:center;justify-content:center}'
      + '.cart-item .cart-item__name{display:inline-block;padding:9px 0}'
      + 'cart-items option[disabled],cart-drawer-items option[disabled]{color:#9a8a76}'
      + '.hs-line-gone{margin:6px 0 0;color:#a3261b;font-size:13px;line-height:1.35;font-weight:700}'
      // «ПРОДУКТ» / «ВСЬОГО» were 9px at about 3.3:1 — under AA for text.
      + 'th[id*="Column"]{font-size:12px!important;color:#663E19!important;opacity:1!important}';
    document.head.appendChild(st);
  }

  // ── Set discount line in the cart ──
  // 2026-09-17: the cart briefly applied Buy20/25/30 by item count; the owner
  // wants the set discount to come from the bundles page only. The cart now
  // just tells what sets cost and links to the builder; a set code that is
  // already on the cart (it came from that page) is named as applied.
  var SET_TIERS = [
    { min: 4, code: 'Buy30', pct: 30 },
    { min: 3, code: 'Buy25', pct: 25 },
    { min: 2, code: 'Buy20', pct: 20 },
  ];
  // The quiz's «Комплект» card (hs-quiz.js, test quiz-result-set) prices a
  // pair from these same tiers, so the price it shows is the code this cart
  // then applies.
  window.HSSets = { tiers: SET_TIERS.map(function (t) { return { min: t.min, code: t.code, pct: t.pct }; }) };
  var BUNDLES_URL = '/pages/%D0%B7%D0%B0%D0%BE%D1%89%D0%B0%D0%B4%D0%B6%D1%83%D0%B9-%D0%B4%D0%BE-2-2312-%D1%83-%D0%BD%D0%B0%D0%B1%D0%BE%D1%80%D0%B0%D1%85';
  var _sets = null;

  function setTierByCode(code) {
    var c = String(code || '').toLowerCase();
    for (var i = 0; i < SET_TIERS.length; i++) if (SET_TIERS[i].code.toLowerCase() === c) return SET_TIERS[i];
    return null;
  }

  function renderSetsLine() {
    var s = _sets;
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(function (anchor) {
      // hs-lab's gift bar can land between the cart and this line, so look at
      // every sibling, not just the next one (two lines showed on /cart, 23.10).
      var all = anchor.parentElement ? [].filter.call(anchor.parentElement.children, function (c) { return c.classList.contains('hs-sets'); }) : [];
      for (var i = 1; i < all.length; i++) all[i].remove();
      var el = all[0] || null;
      // The offer goes to one-item carts: 2+ items already earn like a set at full
      // price (/admin/tiers/bundles, 30.10), the discount would only cost there.
      if (!s || s.qty < 1 || (s.qty > 1 && !s.applied)) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement('div');
        el.className = 'hs-sets';
        anchor.insertAdjacentElement('afterend', el);
      }
      var key = s.applied ? 'applied:' + s.applied.pct : 'offer';
      if (el.getAttribute('data-key') === key) return;
      el.setAttribute('data-key', key);
      el.textContent = '';
      var p = document.createElement('p');
      p.className = 'hs-sets__text';
      if (s.applied) {
        p.textContent = 'Знижка на набір −' + s.applied.pct + '% врахована.';
        el.appendChild(p);
        return;
      }
      p.textContent = 'Дві речі в наборі: мінус 20%';
      el.appendChild(p);
      var a = document.createElement('a');
      a.className = 'hs-sets__btn';
      a.href = BUNDLES_URL;
      a.textContent = 'Зібрати набір';
      el.appendChild(a);
    });
    injectSetsStyles();
  }

  var _setsStyled = false;
  function injectSetsStyles() {
    if (_setsStyled) return;
    _setsStyled = true;
    var st = document.createElement('style');
    st.id = 'hs-sets-css';
    st.textContent = '.hs-sets{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:10px 16px 4px;padding:4px 0;border-top:1px solid rgba(43,33,28,.14);border-bottom:1px solid rgba(43,33,28,.14);color:#2B211C;font-size:14px;line-height:1.4}' +
      '.hs-sets__text{margin:0;flex:1 1 auto;font-weight:400}' +
      '.hs-sets__btn{display:inline-flex;align-items:center;min-height:44px;color:#2B211C;font-size:13px;letter-spacing:.03em;text-decoration:underline;text-underline-offset:3px;white-space:nowrap}' +
      'cart-items + .hs-sets{margin:12px 0}';
    document.head.appendChild(st);
  }

  // The set price follows her once she has used the bundle page (owner,
  // 2026-09-27): picking something in the builder marks her cart, and from
  // then on every cart read puts the right code on it by how many things are
  // in it — 2 → Buy20, 3 → Buy25, 4+ → Buy30 — and takes it off below 2.
  // Carts that never touched the bundle page are left exactly as they are
  // (17.09: no automatic discount for everyone), and a code she typed or
  // applied herself — a promo, a review reward, her cashback — is never replaced.
  var SETS_ATTR = '_hs_sets';
  var _setsBusy = false;

  function wantedSetCode(cart) {
    if (!cart || !cart.attributes || cart.attributes[SETS_ATTR] !== '1') return null;   // not hers to change
    // v49: during Black Friday (hs-bf.js) no set code goes on, and one already on comes off.
    if (typeof window !== 'undefined' && window.__HS_SETS_OFF) {
      return (cart.discount_codes || []).some(function (c) { return setTierByCode(c.code); }) ? '' : null;
    }
    var qty = 0;
    (cart.items || []).forEach(function (item) {
      // A gift line (Black Friday bra, _hs_gift) is free: it is not a set item.
      if (!item.gift_card && item.price > 0 && !(item.properties && item.properties._hs_gift)) qty += item.quantity;
    });
    var codes = (cart.discount_codes || []).map(function (c) { return String(c.code || ''); });
    // The lab's gift code (LAB35G) gives way to a set; any other code is hers and stays.
    if (codes.some(function (c) { return c && !setTierByCode(c) && !/^LAB\d+G$/i.test(c); })) return null;
    var want = '';
    for (var i = 0; i < SET_TIERS.length; i++) if (qty >= SET_TIERS[i].min) { want = SET_TIERS[i].code; break; }
    var have = '';
    codes.forEach(function (c) { if (setTierByCode(c)) have = c; });
    return have.toLowerCase() === want.toLowerCase() ? null : want;   // null: nothing to change
  }

  // Each change is tried once per cart and code: if Shopify ever refuses it,
  // the cart page must not reload itself in a loop trying again.
  function setTried(key) {
    try { if (sessionStorage.getItem('hs_sets_tried') === key) return true; sessionStorage.setItem('hs_sets_tried', key); } catch (e) { /* private mode */ }
    if (applySetCode._last === key) return true;
    applySetCode._last = key;
    return false;
  }

  function applySetCode(want, cart) {
    if (_setsBusy) return;
    if (setTried(String((cart && cart.token) || '') + '|' + want + '|' + String((cart && cart.item_count) || 0))) return;
    var drawer = document.querySelector('cart-drawer');
    var drawerOpen = !!(drawer && drawer.classList.contains('active') && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function');
    var body = { discount: want };
    if (drawerOpen) body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
    _setsBusy = true;
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (drawerOpen && state && state.sections) {
          try { drawer.renderContents(state); } catch (e) { /* the next cart read corrects the total */ }
        } else if (window.location.pathname.replace(/\/+$/, '') === '/cart') {
          // The cart page shows server-rendered totals: one reload shows the new price.
          window.location.reload();
          return;
        }
        if (state) syncSets(state);
      })
      .catch(function () { /* prices stay as the cart has them */ })
      .then(function () { _setsBusy = false; });
  }

  function syncSets(cart) {
    if (!cart) return;
    var qty = 0;
    (cart.items || []).forEach(function (item) {
      // A gift line (Black Friday bra, _hs_gift) is free: it is not a set item.
      if (!item.gift_card && item.price > 0 && !(item.properties && item.properties._hs_gift)) qty += item.quantity;
    });
    var applied = null;
    (cart.discount_codes || []).forEach(function (c) {
      var t = setTierByCode(c.code);
      if (t && c.applicable) applied = t;
    });
    _sets = { qty: qty, applied: applied };
    renderSetsLine();
    var want = wantedSetCode(cart);
    if (want !== null) applySetCode(want, cart);
  }

  // The whole order leaves in one parcel once every item is there, so the cart
  // names the latest pre-order date. etas arrive sorted (ISO dates).
  function latestEta(etas) {
    return etas && etas.length ? formatDate(etas[etas.length - 1]) : '';
  }

  // The theme promises «1-2 дні» for every cart. While a pre-order is in it,
  // that is the courier time after shipping — the line says so, and goes back
  // to its own words once the pre-order is gone.
  function softenDeliveryPromise(root, on) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n, nodes = [];
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      if (t.__hsPoOrig === undefined && !/1[-\u2013]2 дн/i.test(t.textContent)) return;
      if (on) {
        if (t.__hsPoOrig === undefined) t.__hsPoOrig = t.textContent;
        var v = t.__hsPoOrig.replace(/(1[-\u2013]2 дн[іi])(?! після)/i, '$1 після відправки');
        if (t.textContent !== v) t.textContent = v;
      } else if (t.__hsPoOrig !== undefined && t.textContent !== t.__hsPoOrig) {
        t.textContent = t.__hsPoOrig;
      }
    });
  }

  // Where the banner goes: in the page flow, right above the checkout button —
  // unless the button lives in a fixed/sticky bar (Debutify's mobile cart),
  // in which case the banner goes above that bar. Inside the bar it grew the
  // bar to a third of the screen and covered the Nova Poshta city and branch
  // lists that open under their inputs.
  function bannerAnchor(btn) {
    var boundary = btn.closest('cart-drawer, .cart-drawer, .drawer, #CartDrawer, .mini-cart, main') || document.body;
    var e = btn.parentElement;
    while (e && e !== boundary && e !== document.body) {
      var pos = getComputedStyle(e).position;
      if (pos === 'fixed' || pos === 'sticky') return e;
      e = e.parentElement;
    }
    return btn;
  }

  // «Відправити частинами» (v38). The tick is a cart attribute, so it reaches
  // the order; the app splits the paid order in two (/orders/split).
  var SPLIT_ATTR = 'Відправка частинами';
  var SPLIT_YES = 'Так';
  var _cartHasStock = false;
  var _cartSplit = false;
  // Saves still on their way. The box stays usable (a disabled box drops
  // keyboard focus); the cart is read back once the last one lands.
  var _splitPending = 0;

  function splitOffered(hasPreorder) {
    return !!hasPreorder && _cartHasStock && (_settings.split_enabled === 1 || _settings.split_enabled === true);
  }

  function saveSplit(on) {
    _splitPending++;
    _cartSplit = !!on;
    var attrs = {};
    attrs[SPLIT_ATTR] = on ? SPLIT_YES : '';
    renderCartUI(_lastCartHasPreorder, _cartEtas);
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); })
      .catch(function () { /* the read-back below shows what the cart really holds */ })
      .then(function () { _splitPending--; if (!_splitPending) refreshCartState(); });
  }

  function splitControl(on) {
    var label = document.createElement('label');
    label.className = 'hs-po-split';
    var box = document.createElement('input');
    box.type = 'checkbox';
    box.checked = !!on;
    var words = document.createElement('span');
    var title = document.createElement('span');
    title.textContent = _settings.split_label_text || '';
    words.appendChild(title);
    if (_settings.split_note_text) {
      var note = document.createElement('small');
      note.textContent = _settings.split_note_text;
      words.appendChild(note);
    }
    label.appendChild(box);
    label.appendChild(words);
    box.addEventListener('change', function () { saveSplit(box.checked); });
    return label;
  }

  function renderCartUI(hasPreorder, etas) {
    document.querySelectorAll('.hs-po-cod-banner').forEach(function (e) { e.parentNode && e.parentNode.removeChild(e); });
    etas = etas || [];
    var keep = [];

    var candidates = document.querySelectorAll([
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href$="/checkout"]',
      'a[href*="/checkouts/"]',
      '.cart__checkout',
      '[data-checkout-button]',
    ].join(', '));

    var offered = splitOffered(hasPreorder);
    var split = offered && _cartSplit;
    var text = String((split ? _settings.split_on_text : _settings.cart_warning_text) || '').replace(/\{\{\s*eta\s*\}\}/g, latestEta(etas));
    var codOn = !(_settings.cod_warning_enabled === 0 || _settings.cod_warning_enabled === false);
    var cod = codOn && _settings.cod_warning_text ? applyTemplate(_settings.cod_warning_text, etas[0]) : '';
    // The tick is part of what is drawn, so ticking redraws.
    var wanted = text + '\n' + cod + (offered ? '\n[split ' + (split ? 1 : 0) + ']' : '');

    candidates.forEach(function (btn) {
      if (!btn.offsetParent && btn.getClientRects().length === 0) return;  // not visible
      var container = btn.closest('form, .cart-drawer, .drawer, .cart, .mini-cart, cart-drawer') || btn.parentElement;
      if (!container) return;
      softenDeliveryPromise(container.closest('cart-drawer, .cart, main, body') || container, !!hasPreorder);
      if (!hasPreorder) return;

      var anchor = bannerAnchor(btn);
      var prev = anchor.previousElementSibling;
      var banner = prev && prev.classList && prev.classList.contains('hs-po-cart-banner') ? prev : null;
      if (banner && banner.getAttribute('data-hs-text') === wanted) { keep.push(banner); return; }   // nothing changed: no churn
      if (!banner) {
        injectPickerStyles();
        banner = document.createElement('div');
        banner.className = 'hs-po-cart-banner';
        banner.setAttribute('role', 'note');
        anchor.parentNode.insertBefore(banner, anchor);
      }
      // Someone ticking with the keyboard keeps focus on the box through the redraw.
      var refocus = !!(document.activeElement && banner.contains(document.activeElement));
      banner.setAttribute('data-hs-text', wanted);
      banner.innerHTML = '<span class="hs-po-legend__ic hs-po-legend__ic--po" aria-hidden="true"></span><div><p></p></div>';
      banner.querySelector('p').textContent = text;
      if (cod) {
        var p2 = document.createElement('p');
        p2.textContent = cod;
        banner.querySelector('div').appendChild(p2);
      }
      if (offered) {
        var ctl = splitControl(split);
        banner.querySelector('div').appendChild(ctl);
        if (refocus) { try { ctl.querySelector('input').focus({ preventScroll: true }); } catch (e) { /* old browsers */ } }
      }
      keep.push(banner);
    });
    document.querySelectorAll('.hs-po-cart-banner').forEach(function (b) { if (keep.indexOf(b) === -1 && b.parentNode) b.parentNode.removeChild(b); });
    dlvCartState(hasPreorder, etas);
  }

  // ══════════════════════════════════════════════════════════════════════════
  // VIP EARLY ACCESS (v36)
  // New products announced to VIP and Gold stay hidden from everyone else for
  // the early-access window: their cards disappear from collections, search
  // and recommendations, and their product page shows a lock in place of the
  // add-to-cart button. A VIP or Gold customer arrives through the personal
  // link in her email (?hs_vip=...); the app verifies it once and this browser
  // stays unlocked. Soft by design: it hides and blocks the button, it does
  // not police the cart. Any failure leaves the store fully open.
  // ══════════════════════════════════════════════════════════════════════════
  var VIP_STORE_KEY = 'hs_vip_early';
  var _vipLocks = null;
  var _vipTimer = null;
  var _vipPageLocked = false;

  function vipOrigin() {
    var u = window.__HS_PREORDER_API || window.__HS_PREORDER_SETTINGS_API || '';
    if (!u) return '';
    try { return new URL(u, window.location.href).origin; } catch (e) { return ''; }
  }
  function vipRead() {
    try { return JSON.parse(window.localStorage.getItem(VIP_STORE_KEY) || 'null'); } catch (e) { return null; }
  }
  function vipWrite(v) {
    try { window.localStorage.setItem(VIP_STORE_KEY, JSON.stringify(v)); } catch (e) {}
  }
  function vipUnlocked() {
    var s = vipRead();
    return !!(s && s.exp && Date.parse(s.exp) > Date.now());
  }
  function vipHandleOf(href) {
    if (!href || href.indexOf('/products/') === -1) return null;
    try {
      var path = new URL(href, window.location.href).pathname;
      var rest = path.split('/products/')[1] || '';
      var h = rest.split('/')[0];
      return h ? decodeURIComponent(h).toLowerCase() : null;
    } catch (e) { return null; }
  }
  function vipWhen(iso) {
    try {
      return new Date(iso).toLocaleString('uk-UA', { timeZone: 'Europe/Kyiv', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
    } catch (e) { return ''; }
  }
  function vipProductId() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.product && meta.product.id) return String(meta.product.id);
    } catch (e) {}
    var inp = document.querySelector('main form[action*="/cart/add"] input[name="product-id"]');
    return inp && inp.value ? String(inp.value) : null;
  }
  function injectVipStyles() {
    if (document.getElementById('hs-vip-early-css')) return;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#9C7466" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
    var lock = 'url("data:image/svg+xml;utf8,' + encodeURIComponent(svg) + '")';
    var css = [
      '[data-hs-vip-hidden="1"], [data-hs-vip-locked="1"] { display: none !important; }',
      '.hs-vip-lock { display: flex; gap: 10px; align-items: flex-start; width: 100%; box-sizing: border-box; margin: 10px 0; padding: 12px 14px; background: #FAF4F1; border: 1px solid #E7D5CC; border-radius: 12px; color: #6B4F45; font-size: 14px; line-height: 1.45; text-align: left; letter-spacing: 0; text-transform: none; }',
      '.hs-vip-lock__ic { flex: 0 0 18px; width: 18px; height: 18px; margin-top: 1px; background: ' + lock + ' center / 18px 18px no-repeat; }',
      '.hs-vip-lock p { margin: 0; }',
      '.hs-vip-lock__t { font-weight: 700; color: #2B211E; }'
    ].join(' ');
    var st = document.createElement('style');
    st.id = 'hs-vip-early-css';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }
  function applyVipLocksSoon() {
    if (_vipTimer) return;
    _vipTimer = setTimeout(function () { _vipTimer = null; applyVipLocks(); }, 150);
  }
  function applyVipLocks() {
    if (!_vipLocks || vipUnlocked()) return;
    // Cards wherever they render: collections, search, recommendations, predictive search.
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var h = vipHandleOf(links[i].getAttribute('href'));
      if (!h || !Object.prototype.hasOwnProperty.call(_vipLocks.byHandle, h)) continue;
      var card = links[i].closest('li.grid__item, .grid__item, .predictive-search__list-item, predictive-search li, .search-results li');
      if (card && card.getAttribute('data-hs-vip-hidden') !== '1') card.setAttribute('data-hs-vip-hidden', '1');
    }
    // The locked product's own page: no add-to-cart, a clear note instead.
    if (window.location.pathname.indexOf('/products/') === -1) return;
    var pid = vipProductId();
    if (!pid || !Object.prototype.hasOwnProperty.call(_vipLocks.byId, pid)) return;
    _vipPageLocked = true;
    var until = _vipLocks.byId[pid];
    var forms = document.querySelectorAll('main form[action*="/cart/add"]');
    for (var f = 0; f < forms.length; f++) {
      var btns = forms[f].querySelectorAll('button[type="submit"], button[name="add"], input[type="submit"], .shopify-payment-button, shopify-accelerated-checkout');
      if (!btns.length) continue;
      for (var b = 0; b < btns.length; b++) btns[b].setAttribute('data-hs-vip-locked', '1');
      if (forms[f].querySelector('.hs-vip-lock')) continue;
      var note = document.createElement('div');
      note.className = 'hs-vip-lock';
      note.setAttribute('role', 'note');
      var ic = document.createElement('span');
      ic.className = 'hs-vip-lock__ic';
      ic.setAttribute('aria-hidden', 'true');
      var body = document.createElement('div');
      var t = document.createElement('p');
      t.className = 'hs-vip-lock__t';
      t.textContent = 'Ранній доступ для VIP і Gold клієнток';
      var sub = document.createElement('p');
      sub.textContent = (until ? 'Для всіх — з ' + vipWhen(until) + '.' : 'Для всіх — зовсім скоро.') + ' Особисте посилання для доступу — у листі від HolyShape.';
      body.appendChild(t);
      body.appendChild(sub);
      note.appendChild(ic);
      note.appendChild(body);
      btns[0].parentNode.insertBefore(note, btns[0]);
    }
  }
  // Hidden buttons can be re-shown by theme scripts; the submit itself is
  // stopped here, in the capture phase, for the locked product's forms only.
  function blockLockedCart(e) {
    if (!_vipPageLocked || vipUnlocked()) return;
    var el = e.target;
    if (!el || !el.closest) return;
    var form = el.closest('main form[action*="/cart/add"]');
    if (!form) return;
    if (e.type === 'submit' || el.closest('button[type="submit"], button[name="add"], input[type="submit"]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }
  function initVipEarlyAccess() {
    var origin = vipOrigin();
    if (!origin || typeof fetch !== 'function') return;
    var params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) {}
    var token = params ? params.get('hs_vip') : null;
    var ready = Promise.resolve();
    if (token) {
      ready = fetch(origin + '/api/vip-early-access/verify?t=' + encodeURIComponent(token), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.ok && j.exp) vipWrite({ exp: j.exp }); })
        .catch(function () {})
        .then(function () {
          // Take the token out of the address bar so a copied link does not carry it.
          try {
            params.delete('hs_vip');
            var q = params.toString();
            window.history.replaceState(window.history.state, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
          } catch (e) {}
        });
    }
    ready.then(function () {
      if (vipUnlocked()) return null;
      return fetch(origin + '/api/vip-early-access').then(function (r) { return r.json(); });
    }).then(function (j) {
      var list = (j && j.locks) || [];
      if (!list.length) return;
      _vipLocks = { byId: {}, byHandle: {} };
      list.forEach(function (l) {
        if (l.id) _vipLocks.byId[String(l.id)] = l.until || null;
        if (l.handle) _vipLocks.byHandle[String(l.handle).toLowerCase()] = l.until || null;
      });
      injectVipStyles();
      applyVipLocks();
      document.addEventListener('submit', blockLockedCart, true);
      document.addEventListener('click', blockLockedCart, true);
      try { new MutationObserver(applyVipLocksSoon).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    }).catch(function () {});
  }

  // ══════════════════════════════════════════════════════════════════════════
  // hs-delivery-block BEGIN — «ДОСТАВКА Й ОПЛАТА» (v39)
  // A quiet block under the buy button on the product page and next to the
  // delivery picker in the cart: when we ship, how she can pay, what happens
  // if it does not fit. Every fact comes from settings.delivery_block (Settings
  // → Вітрина); nothing shows while its switch is off, while the settings are
  // missing, or when the settings fetch failed. The owner can look first in
  // her own browser with ?hs_delivery_preview=1 (=0 turns that off).
  // The ship line never invents a date: a pre-order size uses the same ETA as
  // the legend and the notice, the cart uses the whole-order date of the cart
  // line. Self-contained: DOM built with createElement, own stylesheet, own
  // timer; hooks elsewhere are three one-line calls (settings arrived, product
  // state applied, cart line drawn).
  // ══════════════════════════════════════════════════════════════════════════

  /* hs-delivery-block:compose:begin — pure, no DOM; services/delivery-block.js runs this same code */
  // cfg: settings.delivery_block · ctx: { place: 'product'|'cart', preorder,
  // eta (already formatted, e.g. «5 жовтня»), inStock (true|false|null), split, preview }
  // → null, or { rows: [{ kind, label, text }], more: { label, url } | null }
  function hsDeliveryCompose(cfg, ctx) {
    ctx = ctx || {};
    if (!cfg || typeof cfg !== 'object') return null;
    if (!(Number(cfg.enabled) === 1 || cfg.enabled === true || ctx.preview)) return null;
    var str = function (v) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim(); };
    var list = function (v) {
      var a = Object.prototype.toString.call(v) === '[object Array]' ? v : String(v == null ? '' : v).split('\n');
      var out = [];
      for (var i = 0; i < a.length; i++) { var s = str(a[i]); if (s) out.push(s); }
      return out;
    };
    var eta = str(ctx.eta);
    var inStockText = str(cfg.ship_in_stock);
    // A product page for a size that is neither in stock nor on pre-order has
    // nothing to buy: no block at all.
    if (ctx.place !== 'cart' && !ctx.preorder && ctx.inStock === false) return null;

    var rows = [];
    var ship = '';
    if (ctx.place === 'cart') {
      if (ctx.preorder && eta) {
        ship = ctx.split && inStockText
          ? 'що є в наявності — ' + inStockText + ', передзамовлення — близько ' + eta
          : 'усе замовлення однією посилкою — близько ' + eta;
      } else if (!ctx.preorder) {
        ship = inStockText;
      }
    } else if (ctx.preorder) {
      if (eta) ship = 'близько ' + eta;
    } else if (ctx.inStock === true) {
      ship = inStockText;
    }
    if (ship) rows.push({ kind: 'ship', label: 'Коли відправимо', text: ship });

    var pay = list(cfg.pay_methods);
    if (pay.length) rows.push({ kind: 'pay', label: 'Оплата', text: pay.join(' · ') });
    var back = list(cfg.return_lines);
    if (back.length) rows.push({ kind: 'return', label: 'Якщо не підійде', text: back.join(' · ') });
    var tryon = str(cfg.tryon_text);
    if (tryon) rows.push({ kind: 'note', label: '', text: tryon });
    if (!rows.length) return null;

    var url = str(cfg.more_url);
    var more = null;
    if (/^https:\/\/[^\s"'<>]+$/i.test(url) || /^\/[^\s"'<>\/][^\s"'<>]*$/.test(url)) {
      more = { label: str(cfg.more_label) || 'Докладніше', url: url };
    }
    return { rows: rows, more: more };
  }
  /* hs-delivery-block:compose:end */

  var DLV_PREVIEW_KEY = 'hs_delivery_preview';
  var _dlvPreview = (function () {
    var m = null;
    try {
      m = /[?&]hs_delivery_preview=([01])/.exec(window.location.search);
      if (m && m[1] === '1') window.localStorage.setItem(DLV_PREVIEW_KEY, '1');
      if (m && m[1] === '0') window.localStorage.removeItem(DLV_PREVIEW_KEY);
      return window.localStorage.getItem(DLV_PREVIEW_KEY) === '1';
    } catch (e) { return !!(m && m[1] === '1'); }
  })();
  var _dlvProduct = null;   // { form, btn, preorder, eta, variantId }
  var _dlvCart = null;      // { preorder, etas }
  var _dlvTimer = null;

  function dlvConfig() {
    var c = _settings.delivery_block;
    return c && typeof c === 'object' ? c : null;
  }
  function dlvActive() {
    var c = dlvConfig();
    return !!(c && (Number(c.enabled) === 1 || c.enabled === true || _dlvPreview));
  }

  var DLV_ICONS = {
    // truck
    ship: [['path', 'M2.5 6.5h11v9.5h-11z'], ['path', 'M13.5 9.5h4l3 3.2v3.3h-7'], ['circle', '6.5', '17.5', '1.8'], ['circle', '17', '17.5', '1.8']],
    // card
    pay: [['rect', '3', '5.5', '18', '13', '2'], ['path', 'M3 10h18'], ['path', 'M7 14.5h3.5']],
    // back arrow
    'return': [['path', 'M9 5L4.5 9.5 9 14'], ['path', 'M4.5 9.5H15a4.75 4.75 0 0 1 0 9.5h-4']],
  };
  function dlvIcon(kind) {
    var NS = 'http://www.w3.org/2000/svg';
    var box = document.createElement('span');
    box.className = 'hs-dlv__ic';
    box.setAttribute('aria-hidden', 'true');
    var parts = DLV_ICONS[kind];
    if (!parts) return box;
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.8');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('focusable', 'false');
    parts.forEach(function (p) {
      var n = document.createElementNS(NS, p[0]);
      if (p[0] === 'path') n.setAttribute('d', p[1]);
      if (p[0] === 'circle') { n.setAttribute('cx', p[1]); n.setAttribute('cy', p[2]); n.setAttribute('r', p[3]); }
      if (p[0] === 'rect') { n.setAttribute('x', p[1]); n.setAttribute('y', p[2]); n.setAttribute('width', p[3]); n.setAttribute('height', p[4]); n.setAttribute('rx', p[5]); }
      svg.appendChild(n);
    });
    box.appendChild(svg);
    return box;
  }

  function dlvStyles() {
    var color = accentColor();
    var css = [
      '.hs-dlv { display: block; box-sizing: border-box; width: 100%; margin: 14px 0 6px; padding: 12px 0 0; border-top: 1px solid ' + lighten(color, 0.55) + '; font-size: 14px; line-height: 1.45; font-weight: 400; color: #2B211E; text-align: left; letter-spacing: 0; text-transform: none; }',
      '.hs-dlv--cart { margin: 0 0 14px; padding: 12px 0; border-bottom: 1px solid ' + lighten(color, 0.55) + '; }',
      '.hs-dlv__row { display: flex; gap: 9px; align-items: flex-start; margin: 0; }',
      '.hs-dlv__row + .hs-dlv__row { margin-top: 5px; }',
      '.hs-dlv__row--note { color: #6B4F45; }',
      '.hs-dlv__ic { flex: 0 0 16px; width: 16px; height: 16px; margin-top: 2px; color: ' + color + '; }',
      '.hs-dlv__ic svg { display: block; width: 16px; height: 16px; }',
      '.hs-dlv p { margin: 0 !important; padding: 0; min-width: 0; overflow-wrap: anywhere; font: inherit; color: inherit; letter-spacing: 0; text-transform: none; }',
      '.hs-dlv b { font-weight: 700; color: #2B211E; }',
      '.hs-dlv__it { display: inline-block; max-width: 100%; }',
      // Cart grounds are often a rose tint themselves: the icons take the ink.
      '.hs-dlv--cart .hs-dlv__ic { color: #6B4F45; }',
      '.hs-dlv__more { display: inline-flex; align-items: center; min-height: 44px; margin: 0 0 -8px 25px; color: #2B211E !important; font-size: 14px; font-weight: 600; text-decoration: underline; text-underline-offset: 3px; text-decoration-color: ' + color + '; }',
    ].join('\n');
    var s = document.getElementById('hs-dlv-styles');
    if (s && s.getAttribute('data-css') === css) return;
    if (!s) {
      s = document.createElement('style');
      s.id = 'hs-dlv-styles';
      (document.head || document.documentElement).appendChild(s);
    }
    s.setAttribute('data-css', css);
    s.textContent = css;
  }

  function dlvFill(el, model) {
    var sig = JSON.stringify(model);
    if (el.getAttribute('data-hs-dlv') === sig) return;
    el.setAttribute('data-hs-dlv', sig);
    while (el.firstChild) el.removeChild(el.firstChild);
    model.rows.forEach(function (r) {
      var row = document.createElement('div');
      row.className = 'hs-dlv__row hs-dlv__row--' + r.kind;
      row.appendChild(dlvIcon(r.kind));
      var p = document.createElement('p');
      if (r.label) {
        var b = document.createElement('b');
        b.textContent = r.label + ': ';
        p.appendChild(b);
      }
      // Each method / term is one unit: lines break between them, not inside.
      var parts = r.text.split(' · ');
      if (parts.length < 2) p.appendChild(document.createTextNode(r.text));
      else parts.forEach(function (t, i) {
        var it = document.createElement('span');
        it.className = 'hs-dlv__it';
        it.textContent = t + (i < parts.length - 1 ? ' ·' : '');
        p.appendChild(it);
        if (i < parts.length - 1) p.appendChild(document.createTextNode(' '));
      });
      row.appendChild(p);
      el.appendChild(row);
    });
    if (model.more) {
      var a = document.createElement('a');
      a.className = 'hs-dlv__more';
      a.href = model.more.url;
      a.textContent = model.more.label;
      if (/^https:/i.test(model.more.url)) { a.target = '_blank'; a.rel = 'noopener'; }
      el.appendChild(a);
    }
  }
  function dlvNew(place) {
    var el = document.createElement('div');
    el.className = 'hs-dlv hs-dlv--' + place;
    el.setAttribute('role', 'note');
    el.setAttribute('aria-label', 'Доставка й оплата');
    return el;
  }
  function dlvRemove(selector, keep) {
    document.querySelectorAll(selector).forEach(function (n) { if (keep.indexOf(n) === -1 && n.parentNode) n.parentNode.removeChild(n); });
  }

  // Product page: right after the main add-to-cart form (the pre-order notice
  // is the form's last child, so the block reads under it).
  function dlvDrawProduct() {
    var keep = [];
    var st = _dlvProduct;
    var model = null, anchor = null;
    if (st && dlvActive() && !_vipPageLocked) {
      anchor = st.form && st.form.isConnected ? st.form : findMainProductForm();
      var v = findVariant(st.variantId);
      model = hsDeliveryCompose(dlvConfig(), {
        place: 'product',
        preorder: st.preorder,
        eta: st.preorder && st.eta ? formatDate(st.eta) : '',
        inStock: st.preorder ? false : (v ? !!v.available : null),
        preview: _dlvPreview,
      });
    }
    if (model && anchor && anchor.parentNode) {
      dlvStyles();
      var next = anchor.nextElementSibling;
      var el = next && next.classList && next.classList.contains('hs-dlv--product') ? next : null;
      if (!el) { el = dlvNew('product'); anchor.insertAdjacentElement('afterend', el); }
      dlvFill(el, model);
      keep.push(el);
    }
    dlvRemove('.hs-dlv--product', keep);
  }

  // Cart (drawer and /cart): inside the order summary, right under our Nova
  // Poshta picker when it is there. Without a summary it goes above the
  // checkout button, in the page flow — never inside the fixed checkout bar.
  function dlvDrawCart() {
    var keep = [];
    var st = _dlvCart;
    var model = null;
    if (st && dlvActive()) {
      model = hsDeliveryCompose(dlvConfig(), {
        place: 'cart',
        preorder: !!st.preorder,
        eta: st.preorder ? latestEta(st.etas) : '',
        split: splitOffered(st.preorder) && _cartSplit,
        preview: _dlvPreview,
      });
    }
    if (model) {
      var hosts = document.querySelectorAll('.cart-order-summary');
      if (hosts.length) {
        hosts.forEach(function (host) {
          var picker = null, el = null;
          for (var c = host.firstElementChild; c; c = c.nextElementSibling) {
            if (c.classList.contains('hs-np')) picker = c;
            if (c.classList.contains('hs-dlv--cart')) el = c;
          }
          if (!el) el = dlvNew('cart');
          var want = picker ? picker.nextElementSibling : host.firstElementChild;
          if (want !== el) host.insertBefore(el, want);
          keep.push(el);
        });
      } else {
        document.querySelectorAll('button[name="checkout"], input[name="checkout"], .cart__checkout, [data-checkout-button]').forEach(function (btn) {
          if (!btn.offsetParent && btn.getClientRects().length === 0) return;
          var anchor = bannerAnchor(btn);
          var prev = anchor.previousElementSibling;
          if (prev && prev.classList.contains('hs-po-cart-banner')) { anchor = prev; prev = anchor.previousElementSibling; }
          var el = prev && prev.classList.contains('hs-dlv--cart') ? prev : dlvNew('cart');
          if (el !== prev) anchor.parentNode.insertBefore(el, anchor);
          keep.push(el);
        });
      }
      if (keep.length) dlvStyles();
      keep.forEach(function (el) { dlvFill(el, model); });
    }
    dlvRemove('.hs-dlv--cart', keep);
  }

  function dlvDraw() {
    try { dlvDrawProduct(); } catch (e) { /* never break the page */ }
    try { dlvDrawCart(); } catch (e) { /* never break the page */ }
    // Debutify re-renders the form and the cart footer; a light check brings
    // the block back. Runs only while the block is on.
    if (dlvActive() && !_dlvTimer) {
      _dlvTimer = setInterval(function () {
        if (!dlvActive()) return;
        try { dlvDrawProduct(); } catch (e) {}
        try { if (cartVisible() || document.querySelector('.cart-order-summary')) dlvDrawCart(); } catch (e) {}
      }, 1000);
    }
  }
  // Hook: applyPreorderState() — what the chosen size is right now.
  function dlvProductState(form, btn, preorder, eta, variantId) {
    _dlvProduct = { form: form || null, btn: btn || null, preorder: !!preorder, eta: eta || '', variantId: variantId };
    try { dlvDrawProduct(); } catch (e) {}
  }
  // Hook: renderCartUI() — what the cart holds right now.
  function dlvCartState(hasPreorder, etas) {
    _dlvCart = { preorder: !!hasPreorder, etas: etas || [] };
    try { dlvDrawCart(); } catch (e) {}
  }
  // hs-delivery-block END
  // ══════════════════════════════════════════════════════════════════════════

  // ── Add-to-cart safety net ──
  // Seen live (2026-09-17): when Debutify's licence script fails to load, the
  // theme's product-form handler throws before it calls /cart/add, and the
  // button spins forever with nothing added. If a /cart/add form was submitted
  // and no /cart/add request started within ATC_GRACE_MS, submit the plain
  // form ourselves — Shopify adds the item and opens /cart.
  var ATC_GRACE_MS = 3500;
  var _lastCartAddAt = 0;

  function noteCartAdd(url) {
    if (String(url || '').indexOf('/cart/add') !== -1) _lastCartAddAt = Date.now();
  }

  function initAtcSafetyNet() {
    if (window.__hsAtcSafetyNet) return;
    window.__hsAtcSafetyNet = true;
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        try { noteCartAdd(typeof input === 'string' ? input : input && input.url); } catch (e) { /* ignore */ }
        return origFetch.apply(this, arguments);
      };
    }
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { noteCartAdd(url); } catch (e) { /* ignore */ }
      return origOpen.apply(this, arguments);
    };
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var submittedAt = Date.now();
      setTimeout(function () {
        if (_lastCartAddAt >= submittedAt) return;   // the theme sent it
        if (!document.documentElement.contains(form)) return;
        try { labelFormIfPreorder(form); } catch (err) { /* properties are best-effort */ }
        form.querySelectorAll('.loading, [aria-disabled="true"]').forEach(function (el) {
          el.classList.remove('loading');
          el.removeAttribute('aria-disabled');
        });
        console.warn('[HS Preorder] add-to-cart did not start; submitting the form directly');
        HTMLFormElement.prototype.submit.call(form);
      }, ATC_GRACE_MS);
    }, true);
  }

  function boot() {
    initAtcSafetyNet();
    // Fetch per-shop settings first so the initial render uses the merchant's
    // configured text/colors. If the fetch fails we fall through to defaults.
    fetchSettings(function () { init(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
